webpackJsonp([1],{

/***/ 1051:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 375,
	"./af.js": 375,
	"./ar": 383,
	"./ar-dz": 376,
	"./ar-dz.js": 376,
	"./ar-kw": 377,
	"./ar-kw.js": 377,
	"./ar-ly": 378,
	"./ar-ly.js": 378,
	"./ar-ma": 379,
	"./ar-ma.js": 379,
	"./ar-ps": 380,
	"./ar-ps.js": 380,
	"./ar-sa": 381,
	"./ar-sa.js": 381,
	"./ar-tn": 382,
	"./ar-tn.js": 382,
	"./ar.js": 383,
	"./az": 384,
	"./az.js": 384,
	"./be": 385,
	"./be.js": 385,
	"./bg": 386,
	"./bg.js": 386,
	"./bm": 387,
	"./bm.js": 387,
	"./bn": 389,
	"./bn-bd": 388,
	"./bn-bd.js": 388,
	"./bn.js": 389,
	"./bo": 390,
	"./bo.js": 390,
	"./br": 391,
	"./br.js": 391,
	"./bs": 392,
	"./bs.js": 392,
	"./ca": 393,
	"./ca.js": 393,
	"./cs": 394,
	"./cs.js": 394,
	"./cv": 395,
	"./cv.js": 395,
	"./cy": 396,
	"./cy.js": 396,
	"./da": 397,
	"./da.js": 397,
	"./de": 400,
	"./de-at": 398,
	"./de-at.js": 398,
	"./de-ch": 399,
	"./de-ch.js": 399,
	"./de.js": 400,
	"./dv": 401,
	"./dv.js": 401,
	"./el": 402,
	"./el.js": 402,
	"./en-au": 403,
	"./en-au.js": 403,
	"./en-ca": 404,
	"./en-ca.js": 404,
	"./en-gb": 405,
	"./en-gb.js": 405,
	"./en-ie": 406,
	"./en-ie.js": 406,
	"./en-il": 407,
	"./en-il.js": 407,
	"./en-in": 408,
	"./en-in.js": 408,
	"./en-nz": 409,
	"./en-nz.js": 409,
	"./en-sg": 410,
	"./en-sg.js": 410,
	"./eo": 411,
	"./eo.js": 411,
	"./es": 415,
	"./es-do": 412,
	"./es-do.js": 412,
	"./es-mx": 413,
	"./es-mx.js": 413,
	"./es-us": 414,
	"./es-us.js": 414,
	"./es.js": 415,
	"./et": 416,
	"./et.js": 416,
	"./eu": 417,
	"./eu.js": 417,
	"./fa": 418,
	"./fa.js": 418,
	"./fi": 419,
	"./fi.js": 419,
	"./fil": 420,
	"./fil.js": 420,
	"./fo": 421,
	"./fo.js": 421,
	"./fr": 424,
	"./fr-ca": 422,
	"./fr-ca.js": 422,
	"./fr-ch": 423,
	"./fr-ch.js": 423,
	"./fr.js": 424,
	"./fy": 425,
	"./fy.js": 425,
	"./ga": 426,
	"./ga.js": 426,
	"./gd": 427,
	"./gd.js": 427,
	"./gl": 428,
	"./gl.js": 428,
	"./gom-deva": 429,
	"./gom-deva.js": 429,
	"./gom-latn": 430,
	"./gom-latn.js": 430,
	"./gu": 431,
	"./gu.js": 431,
	"./he": 432,
	"./he.js": 432,
	"./hi": 433,
	"./hi.js": 433,
	"./hr": 434,
	"./hr.js": 434,
	"./hu": 435,
	"./hu.js": 435,
	"./hy-am": 436,
	"./hy-am.js": 436,
	"./id": 437,
	"./id.js": 437,
	"./is": 438,
	"./is.js": 438,
	"./it": 440,
	"./it-ch": 439,
	"./it-ch.js": 439,
	"./it.js": 440,
	"./ja": 441,
	"./ja.js": 441,
	"./jv": 442,
	"./jv.js": 442,
	"./ka": 443,
	"./ka.js": 443,
	"./kk": 444,
	"./kk.js": 444,
	"./km": 445,
	"./km.js": 445,
	"./kn": 446,
	"./kn.js": 446,
	"./ko": 447,
	"./ko.js": 447,
	"./ku": 449,
	"./ku-kmr": 448,
	"./ku-kmr.js": 448,
	"./ku.js": 449,
	"./ky": 450,
	"./ky.js": 450,
	"./lb": 451,
	"./lb.js": 451,
	"./lo": 452,
	"./lo.js": 452,
	"./lt": 453,
	"./lt.js": 453,
	"./lv": 454,
	"./lv.js": 454,
	"./me": 455,
	"./me.js": 455,
	"./mi": 456,
	"./mi.js": 456,
	"./mk": 457,
	"./mk.js": 457,
	"./ml": 458,
	"./ml.js": 458,
	"./mn": 459,
	"./mn.js": 459,
	"./mr": 460,
	"./mr.js": 460,
	"./ms": 462,
	"./ms-my": 461,
	"./ms-my.js": 461,
	"./ms.js": 462,
	"./mt": 463,
	"./mt.js": 463,
	"./my": 464,
	"./my.js": 464,
	"./nb": 465,
	"./nb.js": 465,
	"./ne": 466,
	"./ne.js": 466,
	"./nl": 468,
	"./nl-be": 467,
	"./nl-be.js": 467,
	"./nl.js": 468,
	"./nn": 469,
	"./nn.js": 469,
	"./oc-lnc": 470,
	"./oc-lnc.js": 470,
	"./pa-in": 471,
	"./pa-in.js": 471,
	"./pl": 472,
	"./pl.js": 472,
	"./pt": 474,
	"./pt-br": 473,
	"./pt-br.js": 473,
	"./pt.js": 474,
	"./ro": 475,
	"./ro.js": 475,
	"./ru": 476,
	"./ru.js": 476,
	"./sd": 477,
	"./sd.js": 477,
	"./se": 478,
	"./se.js": 478,
	"./si": 479,
	"./si.js": 479,
	"./sk": 480,
	"./sk.js": 480,
	"./sl": 481,
	"./sl.js": 481,
	"./sq": 482,
	"./sq.js": 482,
	"./sr": 484,
	"./sr-cyrl": 483,
	"./sr-cyrl.js": 483,
	"./sr.js": 484,
	"./ss": 485,
	"./ss.js": 485,
	"./sv": 486,
	"./sv.js": 486,
	"./sw": 487,
	"./sw.js": 487,
	"./ta": 488,
	"./ta.js": 488,
	"./te": 489,
	"./te.js": 489,
	"./tet": 490,
	"./tet.js": 490,
	"./tg": 491,
	"./tg.js": 491,
	"./th": 492,
	"./th.js": 492,
	"./tk": 493,
	"./tk.js": 493,
	"./tl-ph": 494,
	"./tl-ph.js": 494,
	"./tlh": 495,
	"./tlh.js": 495,
	"./tr": 496,
	"./tr.js": 496,
	"./tzl": 497,
	"./tzl.js": 497,
	"./tzm": 499,
	"./tzm-latn": 498,
	"./tzm-latn.js": 498,
	"./tzm.js": 499,
	"./ug-cn": 500,
	"./ug-cn.js": 500,
	"./uk": 501,
	"./uk.js": 501,
	"./ur": 502,
	"./ur.js": 502,
	"./uz": 504,
	"./uz-latn": 503,
	"./uz-latn.js": 503,
	"./uz.js": 504,
	"./vi": 505,
	"./vi.js": 505,
	"./x-pseudo": 506,
	"./x-pseudo.js": 506,
	"./yo": 507,
	"./yo.js": 507,
	"./zh-cn": 508,
	"./zh-cn.js": 508,
	"./zh-hk": 509,
	"./zh-hk.js": 509,
	"./zh-mo": 510,
	"./zh-mo.js": 510,
	"./zh-tw": 511,
	"./zh-tw.js": 511
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1051;

/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(906)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(1069),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-08008a58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(911)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(1074),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-471b2f62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(832),
  /* template */
  __webpack_require__(1075),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53fba496",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(913)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(1076),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75491ef5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(907)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(1070),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09714aee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(914)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(1077),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-be2b6bae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(909)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(1072),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c1c7160",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(915)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(1078),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d92c744c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(1071),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d0e6752",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "columns is-gapless wrapper-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-2",
    attrs: {
      "id": "editor"
    }
  }, [_c('EditorSide', {
    ref: "editor"
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-10",
    attrs: {
      "id": "pano"
    }
  }, [_c('noscript', [_c('table', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('tr', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_c('td', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("ERROR:"), _c('br'), _c('br'), _vm._v("Javascript not activated"), _c('br'), _c('br')])])])])])])
}]}

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-page"
  }, [_c('div', {
    attrs: {
      "id": "pano"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-list",
    attrs: {
      "id": "menuItems"
    }
  }, _vm._l((_vm.menus), function(menu, index) {
    return _c('span', {
      key: index,
      staticClass: "menu-item",
      on: {
        "click": function($event) {
          return _vm.menuBtnClick(menu)
        }
      }
    }, [_vm._v(_vm._s(menu.name))])
  }), 0), _vm._v(" "), (_vm.currentLand && _vm.currentLand.areaLevel == 3) ? _c('div', {
    staticClass: "amount-msg"
  }, [_c('p', [_vm._v("剩余数量：" + _vm._s(_vm.getLeftNum))]), _vm._v(" "), _c('p', [_vm._v("总共数量：" + _vm._s(_vm.getTotalNum))])]) : _vm._e(), _vm._v(" "), (_vm.selectedLand) ? _c('div', {
    staticClass: "land-detail"
  }, [_c('p', [_vm._v("地块名称：" + _vm._s(_vm.selectedLand.areaName))]), _vm._v(" "), _c('p', [_vm._v("地块详情：" + _vm._s(_vm.selectedLand.plotSize || 0) + "m²")]), _vm._v(" "), (_vm.selectedLand.buyTime) ? [_c('p', [_vm._v("认购日期：" + _vm._s(_vm.selectedLand.buyTime || ''))]), _vm._v(" "), _c('p', [_vm._v("到期日期：" + _vm._s(_vm.selectedLand.endTime || ''))])] : [_c('p', [_vm._v("有效期年限：" + _vm._s(_vm.selectedLand.effectYear || '-') + "年")]), _vm._v(" "), (!_vm.selectedLand.userId) ? _c('span', {
    staticClass: "purchase-btn",
    on: {
      "click": _vm.toPurchaseDetail
    }
  }, [_vm._v("去认购")]) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), (_vm.currentLand && _vm.currentLand.areaLevel > 1) ? _c('div', {
    staticClass: "back-btn",
    on: {
      "click": _vm.toHigherLand
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "land-list"
  }, _vm._l((_vm.landList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "land-item",
      on: {
        "click": function($event) {
          return _vm.toLowerLand(item)
        }
      }
    }, [_c('img', {
      staticClass: "land-item-image",
      attrs: {
        "src": _vm._f("filterPrefix")(item.areaImg || _vm.placeholderImg)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "land-item-name"
    }, [_vm._v(_vm._s(item.areaName))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 1071:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "dialog-head"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-close",
    on: {
      "click": _vm.close
    }
  }, [_c('a', {
    staticClass: "delete is-medium"
  })])]), _vm._v(" "), _vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "alpha"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1072:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-modal', {
    attrs: {
      "visible": _vm.visible,
      "title": "绑定关联地块vr",
      "footer": null,
      "afterClose": _vm.afterClose,
      "maskClosable": false
    },
    on: {
      "cancel": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 12
      }
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "选择地块"
    }
  }, [_c('a-select', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['value', {
        rules: [{
          required: true,
          message: '请选择'
        }]
      }]),
      expression: "['value', { rules: [{ required: true, message: '请选择' }] }]"
    }],
    staticStyle: {
      "width": "120px"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('a-select-option', {
      key: option.vrId,
      attrs: {
        "value": option.vrId
      }
    }, [_vm._v(_vm._s(option.areaName))])
  }), 1)], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "wrapper-col": {
        span: 12,
        offset: 5
      }
    }
  }, [_c('a-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary",
      "html-type": "submit"
    }
  }, [_vm._v("确认")]), _vm._v(" "), (_vm.vrId) ? _c('a-button', {
    on: {
      "click": _vm.toLandByVr
    }
  }, [_vm._v("查看VR")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1073:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1074:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-2 func-div"
  }, [_c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    on: {
      "click": function($event) {
        return _vm.save2()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toSaveFlag),
      expression: "toSaveFlag"
    }],
    staticClass: "to-save"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    on: {
      "click": function($event) {
        return _vm.preview()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("预览")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    class: {
      'func-selected': _vm.module == 0
    },
    on: {
      "click": function($event) {
        return _vm.changeModule(0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("场景")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    class: {
      'func-selected': _vm.module == 1
    },
    on: {
      "click": function($event) {
        return _vm.changeModule(1)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("视角")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    class: {
      'func-selected': _vm.module == 2
    },
    on: {
      "click": function($event) {
        return _vm.changeModule(2)
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("热点")])]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    class: {
      'func-selected': _vm.module == 3
    },
    on: {
      "click": function($event) {
        return _vm.changeModule(3)
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("土地")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-10",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 0),
      expression: "module == 0"
    }],
    staticClass: "scene-module has-text-white"
  }, [_c('h5', {
    staticClass: "title is-5 has-text-white scene-title"
  }, [_vm._v("场景列表")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._l((_vm.sceneList), function(scene) {
    return _c('div', {
      staticClass: "scene-item",
      class: {
        'scene-item-selected': scene.index == _vm.currentSceneIndex
      }
    }, [_c('div', {
      staticClass: "scene-name",
      on: {
        "click": function($event) {
          return _vm.changeScene(scene)
        }
      }
    }, [_vm._v(_vm._s(scene.name))]), _vm._v(" "), _c('figure', {
      staticClass: "image is-128x128",
      on: {
        "click": function($event) {
          return _vm.changeScene(scene)
        }
      }
    }, [_c('img', {
      staticClass: "thumb",
      attrs: {
        "src": scene.thumburl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "pencil",
      on: {
        "click": function($event) {
          return _vm.showModifyScene(scene)
        }
      }
    }, [_vm._m(6, true)]), _vm._v(" "), _c('div', {
      staticClass: "home",
      on: {
        "click": function($event) {
          return _vm.setWelcome(scene.index)
        }
      }
    }, [_c('a', {
      staticClass: "button is-primary is-inverted is-outlined",
      class: {
        'home-selected': scene.index == _vm.welcomeSceneIndex
      }
    }, [_vm._m(7, true)])]), _vm._v(" "), _c('div', {
      staticClass: "dele",
      on: {
        "click": function($event) {
          return _vm.deleScene(scene)
        }
      }
    }, [_c('a', {
      staticClass: "button is-primary is-inverted is-outlined"
    }, [_c('a-icon', {
      attrs: {
        "type": "delete"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "toLower"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('a', {
    staticClass: "button is-small is-info",
    staticStyle: {
      "width": "100%",
      "height": "30px"
    },
    on: {
      "click": _vm.showPlusSceneModal
    }
  }, [_vm._v("添加场景")])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 1),
      expression: "module == 1"
    }],
    staticClass: "view-module has-text-white",
    on: {
      "mousemove": function($event) {
        return _vm.moveInitFov()
      },
      "mouseup": function($event) {
        return _vm.stopMoveInitFov()
      }
    }
  }, [_c('div', {
    staticClass: "view-content"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("\n            自动旋转\n            "), _c('label', {
    staticClass: "switch is-info view-switch",
    class: {
      'switch-checked': _vm.autoSpinFlag
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoSpinFlag),
      expression: "autoSpinFlag"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoSpinFlag) ? _vm._i(_vm.autoSpinFlag, null) > -1 : (_vm.autoSpinFlag)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.autoSpinFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoSpinFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoSpinFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoSpinFlag = $$c
        }
      }, function($event) {
        return _vm.updatedAutoSpin()
      }]
    }
  })])]), _vm._v(" "), _c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("\n            等待时间（秒）\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoSpinWaitingTime),
      expression: "autoSpinWaitingTime"
    }],
    staticClass: "input is-small",
    attrs: {
      "disabled": !_vm.autoSpinFlag
    },
    domProps: {
      "value": (_vm.autoSpinWaitingTime)
    },
    on: {
      "change": function($event) {
        return _vm.updatedAutoSpin()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autoSpinWaitingTime = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "view-slider"
  }, [_c('div', {
    staticClass: "view-top-slider",
    on: {
      "mousedown": function($event) {
        return _vm.startMoveInitFov()
      }
    }
  }, [_c('span', {
    style: ({
      left: _vm.initFovLeft + 'px'
    })
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  })])]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "max": 180,
      "tooltipDir": ['bottom', 'bottom'],
      "dotSize": 12,
      "show": _vm.module == 1
    },
    model: {
      value: (_vm.sliderValue),
      callback: function($$v) {
        _vm.sliderValue = $$v
      },
      expression: "sliderValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "columns has-text-centered"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('span', [_vm._v("最近")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minFov),
      expression: "minFov"
    }],
    staticClass: "input is-small",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.minFov)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minFov = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('span', [_vm._v("初始")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initFov),
      expression: "initFov"
    }],
    staticClass: "input is-small",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.initFov)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.initFov = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('span', [_vm._v("最远")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxFov),
      expression: "maxFov"
    }],
    staticClass: "input is-small",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.maxFov)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxFov = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 2),
      expression: "module == 2"
    }],
    staticClass: "hotspot-module"
  }, [_c('div', {
    staticClass: "hotspot-add"
  }, [_c('a', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        return _vm.showHotspotDetail()
      }
    }
  }, [_vm._v("添加热点")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "hotspot-list"
  }, _vm._l((_vm.hotspotList), function(hotspotItem) {
    return _c('div', {
      staticClass: "hotspot-item",
      class: {
        'hotspot-item-selected': _vm.selectedHotspot.name == hotspotItem.name
      },
      on: {
        "click": function($event) {
          return _vm.showHotspotDetail(hotspotItem)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": hotspotItem.url
      }
    }), _vm._v(" "), _c('div', [_vm._v("场景切换")])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 3),
      expression: "module == 3"
    }],
    staticClass: "land-module"
  }, [_c('Land', {
    ref: "land",
    on: {
      "change-land": _vm.changeLand
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHotspotDetailFlag),
      expression: "showHotspotDetailFlag"
    }],
    staticClass: "hotspot-detail"
  }, [_c('div', {
    staticClass: "hotspot-detail-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentHotspot.name ? '编辑' : '新增') + "热点")]), _vm._v(" "), _c('a', {
    staticClass: "delete is-large is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.hideHotspotDetail()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "hotspot-detail-content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("图标样式")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline hotspot-detail-style-list"
  }, _vm._l((_vm.hotspotStyleList), function(style) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('div', {
      staticClass: "hotspot-detail-style",
      class: {
        'hotspot-detail-style-selected': style.name == _vm.currentHotspot.style
      },
      on: {
        "click": function($event) {
          return _vm.selectHotspotStyle(style.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": style.imgUrl
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("热点类型")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "89px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.handleHotspotTypeChange
    },
    model: {
      value: (_vm.currentHotspot.hotspottype),
      callback: function($$v) {
        _vm.$set(_vm.currentHotspot, "hotspottype", $$v)
      },
      expression: "currentHotspot.hotspottype"
    }
  }, _vm._l((_vm.hotSpotTypeOptions), function(option) {
    return _c('a-select-option', {
      key: option.id,
      attrs: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("切换效果")]), _vm._v(" "), _c('a-select', {
    attrs: {
      "defaultValue": "1",
      "size": "small"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("淡入淡出")])], 1)], 1), _vm._v(" "), (_vm.currentHotspot && _vm.currentHotspot.hotspottype == 1) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("目标场景")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline hotspot-detail-scene-list"
  }, _vm._l((_vm.sceneListExceptCurrent), function(scene) {
    return _c('div', {
      staticClass: "column is-6 has-text-centered"
    }, [_c('div', {
      staticClass: "hotspot-detail-scene",
      class: {
        'hotspot-detail-scene-selected': scene.name == _vm.currentHotspot.linkedscene
      },
      on: {
        "click": function($event) {
          return _vm.selectHotspotLinkedScene(scene.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": scene.thumburl
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scene.name))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field hotspot-detail-button"
  }, [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        return _vm.saveCurrentHotspot()
      }
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentHotspot.name),
      expression: "currentHotspot.name"
    }],
    staticClass: "field hotspot-detail-button"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": function($event) {
        return _vm.deleteCurrentHotspot()
      }
    }
  }, [_vm._v("删除")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 1),
      expression: "module == 1"
    }],
    staticClass: "camera"
  }, [_c('div', {
    staticClass: "camera-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-left-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-top-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-top-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-right-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-left-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-bottom-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-bottom-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-right-bottom"
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-info camera-button",
    on: {
      "click": function($event) {
        return _vm.setDefaultView()
      }
    }
  }, [_vm._v("设为初始视角")])]), _vm._v(" "), _c('EditScene', {
    ref: "editScene",
    attrs: {
      "visible": _vm.modalVisible
    },
    on: {
      "cancel": function($event) {
        _vm.modalVisible = false
      },
      "confirm": _vm.editScene
    }
  }), _vm._v(" "), _c('ChooseLand', {
    ref: "choose",
    attrs: {
      "visible": _vm.chooseVisible,
      "areaLevel": _vm.currentLand ? (_vm.currentLand.areaLevel + 1) : 0,
      "areaId": _vm.currentLand ? _vm.currentLand.id : ''
    },
    on: {
      "cancel": function($event) {
        _vm.chooseVisible = false
      },
      "submit": _vm.chooseConfirm,
      "to-land": _vm.toLandByVrId
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-window-restore"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-window-restore"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button is-primary is-inverted is-outlined"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])
}]}

/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    staticClass: "title is-5 has-text-white module-name"
  }, [(_vm.currentLand && _vm.currentLand.areaLevel > 1) ? _c('a-icon', {
    attrs: {
      "type": "rollback"
    },
    on: {
      "click": _vm.toHigherLand
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentLand ? (_vm.currentLand.manorName || _vm.currentLand.areaName) + '（' + _vm.currentLand.areaLevel + '级）' : ''))])], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), (_vm.currentLand && _vm.currentLand.areaLevel < 4) ? _c('div', {
    staticClass: "land-add"
  }, [_c('a', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        return _vm.showLandDetailModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.addLandBtnText))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "land-list"
  }, _vm._l((_vm.landList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "land-item",
      on: {
        "click": function($event) {
          return _vm.showLandDetailModal(item)
        }
      }
    }, [_vm._v(_vm._s(item.manorName || item.areaName))])
  }), 0), _vm._v(" "), _c('LandDetail', {
    ref: "detail",
    attrs: {
      "visible": _vm.detailVisible,
      "areaLevel": _vm.currentLand ? _vm.currentLand.areaLevel : 0,
      "hasBtn": _vm.currLowerLand ? true : false
    },
    on: {
      "delete": _vm.handleLandDelete,
      "cancel": function($event) {
        _vm.detailVisible = false
      },
      "submit": _vm.handleLandSubmit,
      "to-lower": _vm.toLowerLand
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1076:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-page"
  }, [_c('div', {
    attrs: {
      "id": "pano"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-list",
    attrs: {
      "id": "menuItems"
    }
  }, _vm._l((_vm.menus), function(menu, index) {
    return _c('span', {
      key: index,
      staticClass: "menu-item",
      on: {
        "click": function($event) {
          return _vm.menuBtnClick(menu)
        }
      }
    }, [_vm._v(_vm._s(menu.name))])
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a-modal', {
    attrs: {
      "visible": _vm.visible,
      "title": _vm.title,
      "okText": "确认",
      "cancelText": "取消",
      "afterClose": _vm.afterClose,
      "maskClosable": false
    },
    on: {
      "cancel": function($event) {
        return _vm.$emit('cancel')
      },
      "ok": _vm.handleSubmit
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form
    }
  }, [_c('h5', [_vm._v("场景名称")]), _vm._v(" "), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['sceneName', {
        rules: [{
          required: true,
          message: '请输入场景名称'
        }]
      }]),
      expression: "['sceneName', { rules: [{ required: true, message: '请输入场景名称' }] }]"
    }]
  })], 1), _vm._v(" "), _c('h5', [_vm._v("上传封面图")]), _vm._v(" "), _c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": false,
      "action": _vm.$api.uploadUrl,
      "list-type": "picture",
      "headers": _vm.headers,
      "data": _vm.otherParams,
      "file-list": _vm.fileListCover
    },
    on: {
      "change": function (e) { return _vm.handleChange(e, 'cover'); }
    }
  }, [_c('a-button', [_c('a-icon', {
    attrs: {
      "type": "upload"
    }
  }), _vm._v(" 上传图片 ")], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("上传预览图")]), _vm._v(" "), _c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": false,
      "action": _vm.$api.uploadUrl,
      "list-type": "picture",
      "headers": _vm.headers,
      "data": _vm.otherParams,
      "file-list": _vm.fileListPreview
    },
    on: {
      "change": function (e) { return _vm.handleChange(e, 'preview'); }
    }
  }, [_c('a-button', [_c('a-icon', {
    attrs: {
      "type": "upload"
    }
  }), _vm._v(" 上传图片 ")], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("全景图类型")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.imageType),
      callback: function($$v) {
        _vm.imageType = $$v
      },
      expression: "imageType"
    }
  }, _vm._l((_vm.imageTypeOptions), function(option) {
    return _c('a-select-option', {
      key: option.id,
      attrs: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 1), _vm._v(" "), _c('h5', [_vm._v("上传全景图")]), _vm._v(" "), (_vm.imageType === 1) ? _c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": false,
      "action": _vm.$api.uploadUrl,
      "list-type": "picture",
      "headers": _vm.headers,
      "data": _vm.otherParams,
      "file-list": _vm.fileList
    },
    on: {
      "change": function (e) { return _vm.handleChange(e, 'image'); }
    }
  }, [_c('a-button', [_c('a-icon', {
    attrs: {
      "type": "upload"
    }
  }), _vm._v(" 上传图片 ")], 1)], 1) : _c('a-row', {
    attrs: {
      "type": "flex"
    }
  }, _vm._l((_vm.uploadItems), function(item, index) {
    return _c('a-col', {
      key: index,
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "upload-item"
    }, [_c('a-upload', {
      attrs: {
        "multiple": false,
        "data": _vm.typeParams,
        "listType": "picture-card",
        "action": _vm.$api.uploadUrl2,
        "headers": _vm.headers,
        "showUploadList": false,
        "before-upload": function (e) { return _vm.beforeUpload(e, item); }
      },
      on: {
        "preview": _vm.handlePreview,
        "remove": _vm.handleRemove,
        "change": function (e) { return _vm.handleChange(e, 'image', index); }
      }
    }, [(item.path) ? _c('div', {
      staticClass: "upload-img-wrapper",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('img', {
      staticClass: "image-pic",
      attrs: {
        "src": item.path
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "upload-img-view"
    }, [_c('div', {
      staticClass: "ant-upload-list-item-actions-bg"
    }), _vm._v(" "), _c('div', {
      staticClass: "ant-upload-list-item-actions"
    }, [_c('a-icon', {
      staticClass: "upload-control-icon",
      attrs: {
        "type": "eye"
      },
      on: {
        "click": function($event) {
          return _vm.handlePreview(item.path)
        }
      }
    }), _vm._v(" "), _c('a-icon', {
      staticClass: "upload-control-icon",
      attrs: {
        "type": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.handleRemove(index)
        }
      }
    })], 1)])]) : _c('div', [_c('a-icon', {
      attrs: {
        "type": item.loading ? 'loading' : 'plus'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ant-upload-text"
    }, [_vm._v("上传")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "upload-item-text"
    }, [_vm._v(_vm._s(item.name))])], 1)])
  }), 1)], 1)], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "visible": _vm.previewVisible,
      "footer": null,
      "width": "800px"
    },
    on: {
      "cancel": function($event) {
        _vm.previewVisible = false
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "example",
      "src": _vm.previewImage
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-modal', {
    attrs: {
      "visible": _vm.visible,
      "title": _vm.title,
      "footer": null,
      "afterClose": _vm.afterClose,
      "width": 600,
      "maskClosable": false
    },
    on: {
      "cancel": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_c('a-form', {
    attrs: {
      "form": _vm.form,
      "label-col": {
        span: 7
      },
      "wrapper-col": {
        span: 12
      }
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "地块名称"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['areaName', {
        rules: [{
          required: true,
          message: '请输入地块名称'
        }]
      }]),
      expression: "['areaName', { rules: [{ required: true, message: '请输入地块名称' }] }]"
    }]
  })], 1), _vm._v(" "), (_vm.areaLevel >= 1) ? [_c('a-form-item', {
    attrs: {
      "label": "地块标题"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['areaTitle']),
      expression: "['areaTitle']"
    }]
  })], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "简介"
    }
  }, [_c('a-textarea', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['areaBrief']),
      expression: "['areaBrief']"
    }],
    attrs: {
      "placeholder": "",
      "allow-clear": "",
      "auto-size": {
        minRows: 2,
        maxRows: 6
      }
    }
  })], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "上传图片"
    }
  }, [_c('a-upload', {
    attrs: {
      "name": "file",
      "multiple": false,
      "action": _vm.$api.uploadUrl,
      "list-type": "picture",
      "headers": _vm.headers,
      "data": _vm.otherParams,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList
    },
    on: {
      "change": function (e) { return _vm.handleChange(e); }
    }
  }, [_c('a-button', [_c('a-icon', {
    attrs: {
      "type": "upload"
    }
  }), _vm._v(" 上传图片 ")], 1)], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.areaLevel >= 2) ? [_c('a-form-item', {
    attrs: {
      "label": "监控链接"
    }
  }, [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['monitorLink']),
      expression: "['monitorLink']"
    }]
  })], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "价格"
    }
  }, [_c('a-input-number', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['price']),
      expression: "['price']"
    }],
    attrs: {
      "min": 0
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.areaLevel >= 3) ? [_c('a-form-item', {
    attrs: {
      "label": "种植面积"
    }
  }, [_c('a-input-number', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['plotSize']),
      expression: "['plotSize']"
    }],
    attrs: {
      "min": 0,
      "precision": 0
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("m²")])], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "配送次数"
    }
  }, [_c('a-input-number', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['deliveryCount']),
      expression: "['deliveryCount']"
    }],
    attrs: {
      "min": 0,
      "precision": 0
    }
  })], 1), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "label": "有效期年数（年）"
    }
  }, [_c('a-input-number', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: (['effectYear']),
      expression: "['effectYear']"
    }],
    attrs: {
      "min": 0,
      "precision": 0
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('a-form-item', {
    attrs: {
      "wrapper-col": {
        span: 12,
        offset: 7
      }
    }
  }, [_c('a-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary",
      "html-type": "submit"
    }
  }, [_vm._v("确认")]), _vm._v(" "), (_vm.hasBtn) ? _c('a-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      "click": _vm.toLower
    }
  }, [_vm._v("前往")]) : _vm._e(), _vm._v(" "), (_vm.hasBtn) ? _c('a-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.dele
    }
  }, [_vm._v("删除")]) : _vm._e()], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_manage__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_network__ = __webpack_require__(76);




// 新增一级地块
var addManor = function addManor(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["a" /* postAction */])('/api/manor', params);
};
// 获取一级地块
var getManor = function getManor(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["b" /* getAction */])('/api/manor', params);
};
// 修改一级地块
var updateManor = function updateManor(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["c" /* putAction */])('/api/manor', params);
};
// 删除一级地块 
var deleteManor = function deleteManor(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["d" /* deleteAction */])('/api/manor', params);
};
// 导出一级地块
var exportManor = function exportManor() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["e" /* downFile */])('/api/manor/download');
};
// 添加vr
var addVr = function addVr(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["a" /* postAction */])('/api/vr', params);
};
// 查询vr
var getVr = function getVr(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["b" /* getAction */])('/api/vr', params);
};
// 修改vr
var updateVr = function updateVr(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["c" /* putAction */])('/api/vr', params);
};

// 新增二级地块
var addSecondArea = function addSecondArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["a" /* postAction */])('/api/secondArea', params);
};
// 获取二级地块
var getSecondArea = function getSecondArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["b" /* getAction */])('/api/secondArea', params);
};
// 修改二级地块
var updateSecondArea = function updateSecondArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["c" /* putAction */])('/api/secondArea', params);
};
// 删除二级地块 
var deleteSecondArea = function deleteSecondArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["d" /* deleteAction */])('/api/secondArea', params);
};

// 新增三级地块
var addThreeArea = function addThreeArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["a" /* postAction */])('/api/threeArea', params);
};
// 获取三级地块
var getThreeArea = function getThreeArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["b" /* getAction */])('/api/threeArea', params);
};
// 修改三级地块
var updateThreeArea = function updateThreeArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["c" /* putAction */])('/api/threeArea', params);
};
// 删除三级地块 
var deleteThreeArea = function deleteThreeArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["d" /* deleteAction */])('/api/threeArea', params);
};

// 新增四级地块
var addFourArea = function addFourArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["a" /* postAction */])('/api/fourArea', params);
};
// 获取四级地块
var getFourArea = function getFourArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["b" /* getAction */])('/api/fourArea', params);
};
// 修改四级地块
var updateFourArea = function updateFourArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["c" /* putAction */])('/api/fourArea', params);
};
// 删除四级地块 
var deleteFourArea = function deleteFourArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["d" /* deleteAction */])('/api/fourArea', params);
};

// 查询未绑定地块
var unBindArea = function unBindArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["b" /* getAction */])('/api/vrHotSpots/unBindArea', params);
};
// 新增热点
var addVrHotSpots = function addVrHotSpots(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["a" /* postAction */])('/api/vrHotSpots', params);
};
// 获取热点
var getVrHotSpots = function getVrHotSpots(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["b" /* getAction */])('/api/vrHotSpots', params);
};
// 修改热点
var updateVrHotSpots = function updateVrHotSpots(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["c" /* putAction */])('/api/vrHotSpots', params);
};
// 删除热点
var deleteVrHotSpots = function deleteVrHotSpots(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_manage__["d" /* deleteAction */])('/api/vrHotSpots', params);
};

// 文件上传
var uploadUrl = __WEBPACK_IMPORTED_MODULE_1__utils_network__["b" /* baseURL */] + 'api/localStorage';
// 文件上传2  typeId   type
var uploadUrl2 = __WEBPACK_IMPORTED_MODULE_1__utils_network__["b" /* baseURL */] + 'api/localStorage/uploadByType';

/* harmony default export */ __webpack_exports__["a"] = ({
  addManor: addManor,
  getManor: getManor,
  updateManor: updateManor,
  deleteManor: deleteManor,
  exportManor: exportManor,
  addVr: addVr,
  getVr: getVr,
  updateVr: updateVr,
  addSecondArea: addSecondArea,
  getSecondArea: getSecondArea,
  updateSecondArea: updateSecondArea,
  deleteSecondArea: deleteSecondArea,
  addThreeArea: addThreeArea,
  getThreeArea: getThreeArea,
  updateThreeArea: updateThreeArea,
  deleteThreeArea: deleteThreeArea,
  addFourArea: addFourArea,
  getFourArea: getFourArea,
  updateFourArea: updateFourArea,
  deleteFourArea: deleteFourArea,
  unBindArea: unBindArea,
  addVrHotSpots: addVrHotSpots,
  getVrHotSpots: getVrHotSpots,
  updateVrHotSpots: updateVrHotSpots,
  deleteVrHotSpots: deleteVrHotSpots,
  uploadUrl: uploadUrl,
  uploadUrl2: uploadUrl2
});

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_mobileManage__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_network__ = __webpack_require__(76);




// 新增一级地块
var addManor = function addManor(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_mobileManage__["a" /* postAction */])('/api/manor', params);
};
// 获取一级地块
var getManor = function getManor(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_mobileManage__["b" /* getAction */])('/api/manor', params);
};
// 修改一级地块
var updateManor = function updateManor(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_mobileManage__["c" /* putAction */])('/api/manor', params);
};
// 删除一级地块 
var deleteManor = function deleteManor(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_mobileManage__["d" /* deleteAction */])('/api/manor', params);
};

// 首页_地块信息
var getManorDetails = function getManorDetails(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_mobileManage__["b" /* getAction */])('/manor/details/' + params);
};

// 四级地块
var getManorFourArea = function getManorFourArea(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_mobileManage__["b" /* getAction */])('/manor/fourArea/' + params);
};

// 首页_土地认购
var getSubscription = function getSubscription(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_mobileManage__["b" /* getAction */])('/manor/subscription', params);
};

// 土地认购_类别页
var getSubscriptionType = function getSubscriptionType(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_mobileManage__["b" /* getAction */])('/manor/subscriptionType', params);
};

// vr详情
var showVr = function showVr(params) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_mobileManage__["b" /* getAction */])('/manor/showVr/' + params);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getManorDetails: getManorDetails,
  getManorFourArea: getManorFourArea,
  getSubscription: getSubscription,
  getSubscriptionType: getSubscriptionType,
  showVr: showVr
});

/***/ }),

/***/ 514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Editor_vue__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Editor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_MobileVR_vue__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_MobileVR_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_MobileVR_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_MobileIndex_vue__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_MobileIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_MobileIndex_vue__);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);





var routes = [{
  path: '/',
  redirect: '/mobile'
},
// {
//   path: '/editor',
//   component: Editor
// },
{
  path: '/mobile',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_MobileVR_vue___default.a
}, {
  path: '/index',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_MobileIndex_vue___default.a
}, {
  path: '*',
  redirect: '/'
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(910)
}
var Component = __webpack_require__(36)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(1073),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VueAxios */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return service; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return baseURL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axios__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__ = __webpack_require__(86);






// 创建 axios 实例
var baseURL =  true ? 'https://vr.gdyfpt.com/' : '/';
var baseURLMobile = 'https://vr.gdyfpt.com/api';
var service = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: baseURL, // api base_url
  timeout: 9000 // 请求超时时间
});

var serviceMobile = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: baseURLMobile,
  timeout: 9000
});

var err = function err(error) {
  if (error.response) {
    var data = error.response.data;
    var token = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.get('ACCESS_TOKEN');
    // console.log("------异常响应------", token)
    console.log("------异常响应------", error.response.status);
    switch (error.response.status) {
      case 403:
        __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["c" /* notification */].error({
          message: '系统提示',
          description: '拒绝访问',
          duration: 4,
          placement: 'topLeft'
        });
        break;
      case 500:
        //notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
        if (token && data.message == "Token失效，请重新登录") {
          // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          // store.dispatch('Logout').then(() => {
          //     window.location.reload()
          // })
          __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["d" /* Modal */].error({
            title: '登录已过期',
            content: '很抱歉，登录已过期，请重新登录',
            okText: '重新登录',
            mask: false,
            onOk: function onOk() {
              store.dispatch('Logout').then(function () {
                __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].ls.remove('ACCESS_TOKEN');
                window.location.reload();
              });
            }
          });
          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        }
        break;
      case 404:
        __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["c" /* notification */].error({
          message: '系统提示',
          description: '很抱歉，资源未找到!',
          duration: 4,
          placement: 'topLeft'
        });
        break;
      case 504:
        __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["c" /* notification */].error({
          message: '系统提示',
          description: '网络超时',
          placement: 'topLeft'
        });
        break;
      case 401:
        __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["c" /* notification */].error({
          message: '系统提示',
          description: '未授权，请重新登录',
          duration: 4,
          placement: 'topLeft'
        });
        if (token) {
          store.dispatch('Logout').then(function () {
            setTimeout(function () {
              window.location.reload();
            }, 1500);
          });
        }
        break;
      default:
        __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["c" /* notification */].error({
          message: '系统提示',
          description: data.message,
          duration: 4,
          placement: 'topLeft'
        });
        break;
    }
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
};

// request interceptor
service.interceptors.request.use(function (config) {
  // const token = Vue.ls.get('ACCESS_TOKEN')
  var token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

serviceMobile.interceptors.request.use(function (config) {
  var token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  if (response.data.status == 402) {
    __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["c" /* notification */].error({
      message: '登录信息已过期，请重新登录',
      description: '退出登录',
      placement: 'topLeft'
    });
    setTimeout(function () {
      store.dispatch('Logout').then(function () {});
      window.location.reload();
      var sevice = window.location.protocol + "//" + window.location.host + "/";

      var serviceUrl = encodeURIComponent(sevice);
      var casUrl = CAS_URL;
      window.location.href = casUrl + serviceUrl;
    }, 1500);

    return {};
  }
  return res;
}, err);

serviceMobile.interceptors.response.use(function (response) {
  var res = response.data;
  if (response.data.status == 402) {
    return {};
  }
  return res;
}, function (err) {});

var installer = {
  vm: {},
  install: function install(Vue) {
    var router = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Vue.use(__WEBPACK_IMPORTED_MODULE_3__axios__["a" /* VueAxios */], router, service);
  }
};



/***/ }),

/***/ 811:
/***/ (function(module, exports) {

module.exports = {"_from":"ant-design-vue@^1.6.5","_id":"ant-design-vue@1.7.8","_inBundle":false,"_integrity":"sha512-F1hmiS9vwbyfuFvlamdW5l9bHKqRlj9wHaGDIE41NZMWXyWy8qL0UFa/+I0Wl8gQWZCqODW5pN6Yfoyn85At3A==","_location":"/ant-design-vue","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"ant-design-vue@^1.6.5","name":"ant-design-vue","escapedName":"ant-design-vue","rawSpec":"^1.6.5","saveSpec":null,"fetchSpec":"^1.6.5"},"_requiredBy":["/"],"_resolved":"https://registry.npmmirror.com/ant-design-vue/-/ant-design-vue-1.7.8.tgz","_shasum":"1abbf86b68a4f5b1000bea0487b8031dc0001661","_spec":"ant-design-vue@^1.6.5","_where":"C:\\Users\\WenChen\\demo\\tea\\前端代码\\vr","bugs":{"url":"https://github.com/vueComponent/ant-design-vue/issues"},"bundleDependencies":false,"dependencies":{"@ant-design/icons":"^2.1.1","@ant-design/icons-vue":"^2.0.0","@simonwep/pickr":"~1.7.0","add-dom-event-listener":"^1.0.2","array-tree-filter":"^2.1.0","async-validator":"^3.0.3","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-runtime":"6.x","classnames":"^2.2.5","component-classes":"^1.2.6","dom-align":"^1.10.4","dom-closest":"^0.2.0","dom-scroll-into-view":"^2.0.0","enquire.js":"^2.1.6","intersperse":"^1.0.0","is-mobile":"^2.2.1","is-negative-zero":"^2.0.0","ismobilejs":"^1.0.0","json2mq":"^0.2.0","lodash":"^4.17.5","moment":"^2.21.0","mutationobserver-shim":"^0.3.2","node-emoji":"^1.10.0","omit.js":"^1.0.0","raf":"^3.4.0","resize-observer-polyfill":"^1.5.1","shallow-equal":"^1.0.0","shallowequal":"^1.0.2","vue-ref":"^2.0.0","warning":"^4.0.0"},"deprecated":false,"description":"An enterprise-class UI design language and Vue-based implementation","devDependencies":{"@commitlint/cli":"^8.0.0","@commitlint/config-conventional":"^8.0.0","@octokit/rest":"^16.0.0","@vue/cli-plugin-eslint":"^4.0.0","@vue/server-test-utils":"1.0.0-beta.16","@vue/test-utils":"1.0.0-beta.16","acorn":"^7.0.0","autoprefixer":"^9.6.0","axios":"^0.19.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-eslint":"^10.0.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-jest":"^23.6.0","babel-loader":"^7.1.2","babel-plugin-import":"^1.1.1","babel-plugin-inline-import-data-uri":"^1.0.1","babel-plugin-istanbul":"^6.0.0","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-decorators":"^6.24.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-es3-member-expression-literals":"^6.22.0","babel-plugin-transform-es3-property-literals":"^6.22.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"~6.23.0","babel-plugin-transform-vue-jsx":"^3.7.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","case-sensitive-paths-webpack-plugin":"^2.1.2","chalk":"^3.0.0","cheerio":"^1.0.0-rc.2","codecov":"^3.0.0","colorful":"^2.1.0","commander":"^4.0.0","compare-versions":"^3.3.0","cross-env":"^7.0.0","css-loader":"^3.0.0","deep-assign":"^2.0.0","enquire-js":"^0.2.1","eslint":"^6.8.0","eslint-config-prettier":"^6.10.1","eslint-plugin-html":"^6.0.0","eslint-plugin-markdown":"^2.0.0-alpha.0","eslint-plugin-vue":"^6.2.2","fetch-jsonp":"^1.1.3","fs-extra":"^8.0.0","glob":"^7.1.2","gulp":"^4.0.1","gulp-babel":"^7.0.0","gulp-strip-code":"^0.1.4","html-webpack-plugin":"^3.2.0","husky":"^4.0.0","istanbul-instrumenter-loader":"^3.0.0","jest":"^24.0.0","jest-serializer-vue":"^2.0.0","jest-transform-stub":"^2.0.0","js-base64":"^3.0.0","json-templater":"^1.2.0","jsonp":"^0.2.1","less":"^3.9.0","less-loader":"^6.0.0","less-plugin-npm-import":"^2.1.0","lint-staged":"^10.0.0","marked":"0.3.18","merge2":"^1.2.1","mini-css-extract-plugin":"^0.10.0","minimist":"^1.2.0","mkdirp":"^0.5.1","mockdate":"^2.0.2","nprogress":"^0.2.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss":"^7.0.6","postcss-loader":"^3.0.0","prettier":"^1.18.2","pretty-quick":"^2.0.0","querystring":"^0.2.0","raw-loader":"^4.0.0","reqwest":"^2.0.5","rimraf":"^3.0.0","rucksack-css":"^1.0.2","selenium-server":"^3.0.1","semver":"^7.0.0","style-loader":"^1.0.0","stylelint":"^13.0.0","stylelint-config-prettier":"^8.0.0","stylelint-config-standard":"^19.0.0","terser-webpack-plugin":"^3.0.3","through2":"^3.0.0","url-loader":"^3.0.0","vue":"^2.6.11","vue-antd-md-loader":"^1.1.0","vue-clipboard2":"0.3.1","vue-draggable-resizable":"^2.1.0","vue-eslint-parser":"^7.0.0","vue-i18n":"^8.3.2","vue-infinite-scroll":"^2.0.2","vue-jest":"^2.5.0","vue-loader":"^15.6.2","vue-router":"^3.0.1","vue-server-renderer":"^2.6.11","vue-template-compiler":"^2.6.11","vue-virtual-scroller":"^1.0.0","vuex":"^3.1.0","webpack":"^4.28.4","webpack-cli":"^3.2.1","webpack-dev-server":"^3.1.14","webpack-merge":"^4.1.1","webpackbar":"^4.0.0","xhr-mock":"^2.5.1"},"files":["dist","lib","es","types","scripts"],"homepage":"https://www.antdv.com/","keywords":["ant","design","antd","vue","vueComponent","component","components","ui","framework","frontend"],"license":"MIT","main":"lib/index.js","module":"es/index.js","name":"ant-design-vue","peerDependencies":{"vue":"^2.6.0","vue-template-compiler":"^2.6.0"},"repository":{"type":"git","url":"git+https://github.com/vueComponent/ant-design-vue.git"},"scripts":{"codecov":"codecov","compile":"node antd-tools/cli/run.js compile","dev":"webpack-dev-server","dist":"node antd-tools/cli/run.js dist","lint":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./components","lint:docs":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue,.md ./antdv-demo/docs/**/demo/**","lint:site":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./antdv-demo","lint:style":"stylelint \"{site,components}/**/*.less\" --syntax less","postinstall":"node scripts/postinstall || echo \"ignore\"","pre-publish":"node ./scripts/prepub","prepublish":"node antd-tools/cli/run.js guard","prettier":"prettier -c --write '**/*'","pretty-quick":"pretty-quick","pub":"node antd-tools/cli/run.js pub","pub-with-ci":"node antd-tools/cli/run.js pub-with-ci","start":"cross-env NODE_ENV=development webpack-dev-server --config webpack.config.js","test":"cross-env NODE_ENV=test jest --config .jest.js"},"sideEffects":["site/*","components/style.js","components/**/style/*","*.vue","*.md","dist/*","es/**/style/*","lib/**/style/*","*.less"],"title":"Ant Design Vue","typings":"types/index.d.ts","version":"1.7.8"}

/***/ }),

/***/ 829:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditorSide__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditorSide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EditorSide__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    EditorSide: __WEBPACK_IMPORTED_MODULE_0__EditorSide___default.a
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    embedpano({
      // 该文件仅用于Flashplayer，而仅使用HTML5时，则不需要此文件。
      swf: "/static/tour.swf",
      xml: "/static/tour2.xml",
      target: "pano",
      html5: "auto",
      mobilescale: 1.0,
      // 布尔设置。设置为true时，来自html url的所有查询参数将作为变量传递给查看器。
      passQueryParameters: true,
      onready: this.krpano_onready_callback
    });
  },

  methods: {
    krpano_onready_callback: function krpano_onready_callback(krpano) {
      console.log('ready', krpano);
      this.$refs.editor.onready();
    }
  }
});

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MyDialog__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MyDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_MyDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AddScene__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AddScene___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_AddScene__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Land__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Land___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Land__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ChooseLand__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ChooseLand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ChooseLand__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slider_component__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_file_download__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_js_file_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_js_file_download__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var self = null;








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editor',
  components: {
    MyDialog: __WEBPACK_IMPORTED_MODULE_4__components_MyDialog___default.a,
    VueSlider: __WEBPACK_IMPORTED_MODULE_8_vue_slider_component___default.a,
    EditScene: __WEBPACK_IMPORTED_MODULE_5__components_AddScene___default.a,
    ChooseLand: __WEBPACK_IMPORTED_MODULE_7__components_ChooseLand___default.a,
    Land: __WEBPACK_IMPORTED_MODULE_6__Land___default.a
  },
  data: function data() {
    return {
      //  vr数据
      vrData: null,
      // 接口返回scene list
      vrSceneList: [],
      // 当前地块
      currentLand: null,
      // 编辑场景
      modalVisible: false,
      // 热点选择地块
      chooseVisible: false,
      // 热点类型
      hotSpotTypeOptions: [{
        id: "1",
        text: '场景切换'
      }, {
        id: "2",
        text: '关联地块'
      }],
      //krpano对象
      krpano: document.querySelector('#krpanoSWFObject'),
      //当前修改模块：0场景；1视角；2热点
      module: 0,
      //待保存标识
      toSaveFlag: false,
      //场景列表
      sceneList: [],
      //当前场景序号
      currentSceneIndex: -1,
      // 当前场景
      currentScene: null,
      //欢迎页场景序号
      welcomeSceneIndex: -1,
      //展示修改场景名称标识
      showModifySceneFlag: false,
      //待修改场景对象
      toModifyScene: null,
      //自动旋转开启标识
      autoSpinFlag: false,
      //自动旋转等待时间
      autoSpinWaitingTime: 0,
      //最小fov
      minFov: 0,
      //最大fov
      maxFov: 180,
      //初始fov
      initFov: 90,
      //初始fov移动条移动开关
      initFovMoveFlag: false,
      //热点列表
      hotspotList: [],
      //选中移动热点
      selectedHotspot: {},
      //热点移动状态
      isHotspotMoving: false,
      //展示热点详情标识
      showHotspotDetailFlag: false,
      //当前热点
      currentHotspot: {
        style: null,
        linkedscene: null,
        hotspottype: '1'
      },
      //热点图标样式列表
      hotspotStyleList: [{
        name: 'skin_hotspotstyle',
        imgUrl: '../static/skin/vtourskin_hotspot.png'
      }, {
        name: 'skin_hotspotstyle_blue',
        imgUrl: '../static/skin/vtourskin_mapspot.png'
      }, {
        name: 'skin_hotspotstyle_1',
        imgUrl: '../static/skin/1.png'
      }, {
        name: 'skin_hotspotstyle_2',
        imgUrl: '../static/skin/2.png'
      }, {
        name: 'skin_hotspotstyle_3',
        imgUrl: '../static/skin/3.png'
      }, {
        name: 'skin_hotspotstyle_4',
        imgUrl: '../static/skin/4.png'
      }, {
        name: 'skin_hotspotstyle_5',
        imgUrl: '../static/skin/5.png'
      }, {
        name: 'skin_hotspotstyle_6',
        imgUrl: '../static/skin/6.png'
      }, {
        name: 'skin_hotspotstyle_14',
        imgUrl: '../static/skin/14.png'
      }],
      //接口请求状态
      requesting: false
    };
  },

  computed: {
    //场景名称校验
    // sceneNameValid() {
    //   return this.toModifyScene.name && this.toModifyScene.name.length > 0 && this.toModifyScene.name.length < 10
    // },
    //视角拖动条范围值
    sliderValue: {
      get: function get() {
        return [this.minFov, this.maxFov];
      },
      set: function set(val) {
        var min = Math.min(val[0], val[1]);
        var max = Math.max(val[0], val[1]);
        if (this.sceneList[this.currentSceneIndex]) {
          if (this.krpano.get('view.fovmin') != min) {
            this.krpano.set('view.fovmin', min);
            this.sceneList[this.currentSceneIndex].fovmin = min;
            this.toSaveFlag = true;
          }
          if (this.krpano.get('view.fovmax') != max) {
            this.krpano.set('view.fovmax', max);
            this.sceneList[this.currentSceneIndex].fovmax = max;
            this.toSaveFlag = true;
          }
        }
        this.minFov = min;
        this.maxFov = max;
      }
    },
    //视角拖动条上组件左偏移量
    initFovLeft: {
      get: function get() {
        var editor = document.querySelector('#editor');
        var clientWidth = editor ? editor.clientWidth : 256;
        var sliderWidth = clientWidth * 5 / 6 - 32;
        return this.initFov * sliderWidth / 180;
      },
      set: function set(val) {
        var editor = document.querySelector('#editor');
        var clientWidth = editor ? editor.clientWidth : 256;
        var sliderWidth = clientWidth * 5 / 6 - 32;
        this.initFov = Math.round(val * 180 / sliderWidth);
      }
    },
    //除当前场景外场景列表
    sceneListExceptCurrent: function sceneListExceptCurrent() {
      var _this = this;

      var scenes = [];
      this.sceneList.forEach(function (scene) {
        if (scene.index != _this.currentSceneIndex) {
          scenes.push(scene);
        }
      });
      return scenes;
    }
  },
  created: function created() {
    self = this;
  },
  mounted: function mounted() {},

  watch: {
    // landList: {
    //   handler(n, o) {
    //     console.log('neww', n)
    //   },
    //   deep: true
    // }
  },
  methods: {
    //入口js文件已将此函数定义到window，krpano加载完成后调用
    onready: function onready() {
      console.log('myready');
      this.krpano = document.querySelector('#krpanoSWFObject');
      //隐藏下方自带控制条
      this.layerClear();

      //初始化场景
      this.sceneList = this.krpano.get('scene').getArray();
      // xml.scene = 当前scene name
      // var currentScene = this.krpano.get('scene').getItem(this.krpano.get('xml.scene'))
      // var welcomeScene = this.krpano.get('scene').getItem(this.krpano.get('startscene'))
      // this.currentSceneIndex = currentScene ? currentScene.index : -1
      // this.welcomeSceneIndex = welcomeScene ? welcomeScene.index : -1

      //热点移动事件初始化
      var thisVue = this;
      var pano = document.querySelector('#pano');
      // 鼠标松开
      pano.onmouseup = function () {
        thisVue.isHotspotMoving = false;
      };
      // 鼠标移出
      pano.onmouseout = function () {
        thisVue.isHotspotMoving = false;
      };
      // 鼠标经过
      pano.onmousemove = function () {
        thisVue.moveHotspot();
      };
    },
    layerClear: function layerClear() {
      // this.krpano.set('layer[skin_control_bar].visible', false);
      // this.krpano.set('layer[skin_splitter_bottom].visible', false);
      // this.krpano.set('layer[skin_scroll_window].visible', false);
    },

    // modal confirm
    editScene: function editScene(e) {
      var _this2 = this;

      var imageurl = e.imageurl,
          previewurl = e.previewurl,
          thumburl = e.thumburl,
          sceneName = e.sceneName,
          imageType = e.imageType,
          images = e.images;


      console.log('editScene', e);
      console.log(this.toModifyScene);

      if (this.toModifyScene) {
        // 修改场景
        // 检查名称是否重复
        var sceneItem = this.sceneList.find(function (scene) {
          return _this2.toModifyScene.index !== scene.index && sceneName === scene.name;
        });
        if (sceneItem) {
          this.$message.warning('场景名称重复');
          return;
        }

        //修改场景名称（相关联的热点，当前场景scene名称也需修改）
        var oldName = this.sceneList[this.toModifyScene.index].name.toString();

        //修改krpano场景对象名称
        this.krpano.get('scene').renameItem(oldName, sceneName);
        this.sceneList[this.toModifyScene.index].name = sceneName;
        //修改krpano热点指向场景名称
        this.sceneList.forEach(function (scene) {
          if (scene.hotspots && scene.index != _this2.toModifyScene.index) {
            scene.hotspots.forEach(function (hotspot) {
              if (hotspot.linkedscene == oldName) {
                hotspot.linkedscene = sceneName;
                scene.hotspotsModifyFlag = true;
                if (scene.index == _this2.currentSceneIndex) {
                  _this2.krpano.set('hotspot[' + hotspot.name + '].linkedscene', sceneName);
                }
              }
            });
          }
        });
        //  修改封面和图片
        this.krpano.set('scene[' + sceneName + '].imageurl', imageurl);
        this.krpano.set('scene[' + sceneName + '].previewurl', previewurl);
        this.krpano.set('scene[' + sceneName + '].thumburl', thumburl);
        this.krpano.set('scene[' + sceneName + '].images', images);
        this.krpano.set('scene[' + sceneName + '].imagetype', imageType);
        //  修改场景图片
        var modifyIndex = this.toModifyScene.index;
        var content = this.sceneList[modifyIndex].content;

        var imageStartIndex = content.indexOf('<image');
        if (imageStartIndex !== -1) {
          var oldImage = content.slice(imageStartIndex);
          var endIndex = oldImage.indexOf('</image>');
          oldImage = oldImage.slice(0, endIndex + 8);
          var newImageXml = this.getImageXml(imageType, imageurl, images);
          content = content.replace(oldImage, newImageXml);
        }
        // 修改预览图片
        if (previewurl) {
          var previewStartIndex = content.indexOf('<preview');
          var newPreviewXml = '<preview url="' + previewurl + '"/>';
          if (previewStartIndex !== -1) {
            var oldPreview = content.slice(previewStartIndex);
            var endIndex = oldPreview.indexOf('/>');
            oldPreview = oldPreview.slice(0, endIndex + 2);
            content = content.replace(oldPreview, newPreviewXml);
          } else {
            content = content.slice(0, imageStartIndex) + newPreviewXml + content.slice(imageStartIndex);
          }
        }

        this.sceneList[modifyIndex].content = content;

        // 如果修改的是当前场景，加载该场景
        if (modifyIndex === this.currentSceneIndex) {
          this.changeScene(this.sceneList[this.currentSceneIndex], true);
        }
      } else {
        // 添加场景
        // 检查名称是否重复
        var sceneItem = this.sceneList.find(function (scene) {
          return sceneName === scene.name;
        });
        if (sceneItem) {
          this.$message.warning('场景名称重复');
          return;
        }
        this.krpano.call('addscene(' + sceneName + ');');
        this.krpano.set('scene[' + sceneName + '].title', sceneName);

        this.krpano.set('scene[' + sceneName + '].imageurl', imageurl);
        this.krpano.set('scene[' + sceneName + '].previewurl', previewurl);
        this.krpano.set('scene[' + sceneName + '].thumburl', thumburl);
        this.krpano.set('scene[' + sceneName + '].images', images);
        this.krpano.set('scene[' + sceneName + '].imagetype', imageType);

        var previewXmlStr = previewurl ? '<preview url="' + previewurl + '"/>' : '';

        var imageXmlStr = this.getImageXml(imageType, imageurl, images);

        this.krpano.set('scene[' + sceneName + '].content', '\n            <view hlookat="0" vlookat="0" fovtype="MFOV" fov="80" fovmin="50" fovmax="120" limitview="auto"/>\n            ' + previewXmlStr + imageXmlStr + '\n            <autorotate enabled="false" waittime="1.5" accel="1.0" speed="5.0" horizon="0.0"/>\n            ');
        this.changeScene(this.krpano.get('scene').getItem(sceneName));
      }

      // this.sceneList.push(scene)
      // console.log('array', this.krpano.get('scene').getArray())
      // console.log('scenelist', this.sceneList)
      this.modalVisible = false;
      this.toSaveFlag = true;
    },

    // 获取image的xml字符串
    getImageXml: function getImageXml(imageType, imageurl, images) {
      var imageXmlStr = '';
      imageurl = imageurl ? imageurl : '';
      images = images ? images : [];
      if (imageType == 1) {
        imageXmlStr = '\n          <image>\n              <sphere url="' + imageurl + '" />\n          </image>';
      } else if (imageType == 2) {
        var prefix = '';
        var suffix = 'jpg';
        if (images.length > 0 && images[0].imageurl) {
          prefix = images[0].imageurl.split('_')[0];
          suffix = images[0].imageurl.split('.').pop();
        }
        imageXmlStr = '\n          <image type="CUBE">\n            <cube url="' + (prefix + '_%s.' + suffix) + '"/>\n          </image>';
      }
      return imageXmlStr;
    },

    // 加载全部场景
    addAllScene: function addAllScene(list) {
      var _this3 = this;

      this.layerClear();
      if (!list) return;
      list.forEach(function (item, index) {
        var imageXmlStr = _this3.getImageXml(item.imageType, item.imageurl, item.images);
        var previewXmlStr = item.previewurl ? '<preview url="' + item.previewurl + '"/>' : '';

        _this3.krpano.call('addscene(' + item.name + ');');
        // 场景的title即为热点title文字，或热点的text
        _this3.krpano.set('scene[' + item.name + '].title', item.name);
        _this3.krpano.set('scene[' + item.name + '].imageurl', item.imageurl);
        _this3.krpano.set('scene[' + item.name + '].previewurl', item.previewurl);
        _this3.krpano.set('scene[' + item.name + '].thumburl', item.thumburl);
        _this3.krpano.set('scene[' + item.name + '].images', item.images);
        _this3.krpano.set('scene[' + item.name + '].imagetype', item.imageType);
        // this.krpano.set('scene[' + item.name + '].welcomeFlag', item.welcomeFlag)
        _this3.krpano.set('scene[' + item.name + '].content', '\n            <view hlookat="' + (item.initH || 0) + '" vlookat="' + (item.initV || 0) + '" fovtype="MFOV" fov="' + item.fov + '" fovmin="' + item.fovmin + '" fovmax="' + item.fovmax + '" limitview="auto"/>\n            ' + previewXmlStr + imageXmlStr + ('\n            <autorotate enabled="' + (item.autorotate ? item.autorotate.enabled || false : false) + '" waittime="' + (item.autorotate ? item.autorotate.waitTime : 0) + '" accel="1.0" speed="5.0" horizon="0.0"/>\n            '));
        // addhotspot只在有场景时生效
      });

      // 同步数据到sceneList
      for (var x in this.sceneList) {
        var sceneData = list[x];
        if (sceneData) {
          // this.sceneList[x] = Object.assign(sceneData, this.sceneList[x])
          for (var column in sceneData) {
            if (!this.sceneList[x].hasOwnProperty(column)) {
              this.sceneList[x][column] = sceneData[column];
            }
          }
        }
      }

      // 加载初始化场景
      if (this.currentSceneIndex == -1 && this.sceneList) {
        var startIndex = this.sceneList.findIndex(function (item) {
          return item.welcomeFlag === 'true' || item.welcomeFlag === true;
        });
        if (startIndex !== -1) {
          this.welcomeSceneIndex = startIndex;
          this.changeScene(this.sceneList[startIndex]);
        } else if (this.sceneList.length > 0) {
          // 没有设置初始场景，显示第一个
          this.changeScene(this.sceneList[0]);
        }
      }
      console.log('list', this.sceneList);

      //模块数据初始化
      // this.initView()
      // this.initHotSpot()
    },

    // 清除所有场景
    removeAllScene: function removeAllScene() {
      var _this4 = this;

      var sceneNames = this.krpano.get('scene').getArray().map(function (scene) {
        return scene.name;
      });
      console.log('remove', sceneNames);
      console.log(this.sceneList, this.sceneList.length);
      sceneNames.forEach(function (name) {
        _this4.krpano.set('scene[' + name + '].name', null);
      });
      console.log(this.sceneList, this.sceneList.length);
      this.vrData = null;

      this.vrSceneList = [];
      this.currentSceneIndex = -1;
      this.welcomeSceneIndex = -1;
      // this.krpano.call('loadscene(二级地2)', null, 'REMOVESCENES');
    },

    // 添加场景弹框
    showPlusSceneModal: function showPlusSceneModal() {
      if (!this.currentLand) {
        this.$message.warning('请选择地块');
        return;
      }
      this.toModifyScene = null;
      this.modalVisible = true;
    },

    //根据krpano参数初始化视角和热点模块数据
    initView: function initView() {
      //初始化视角参数
      this.autoSpinWaitingTime = this.krpano.get('autorotate.waittime');
      this.autoSpinFlag = this.krpano.get('autorotate.enabled');
      this.minFov = this.krpano.get('view.fovmin');
      this.maxFov = this.krpano.get('view.fovmax');
      this.initFov = this.krpano.get('view.fov');
    },

    //热点初始化
    initHotSpot: function initHotSpot() {
      var _this5 = this;

      // adddhotspot之后热点并不会自动添加到场景中的hotspots中去，手动添加
      // hotspot的keep默认为false，切换场景后自动消失
      if (this.currentScene) {
        // 添加热点
        var hotSpots = this.currentScene.hotspots || this.currentScene.hotSpots;
        if (hotSpots) {
          hotSpots.forEach(function (hotSpot) {
            var linkedscene = hotSpot.linkedscene;
            _this5.krpano.call('addhotspot(' + hotSpot.name + ');');
            _this5.krpano.get('hotspot[' + hotSpot.name + ']').loadstyle(hotSpot.style);
            _this5.krpano.set('hotspot[' + hotSpot.name + '].ath', hotSpot.ath);
            _this5.krpano.set('hotspot[' + hotSpot.name + '].atv', hotSpot.atv);
            _this5.krpano.set('hotspot[' + hotSpot.name + '].linkedscene', linkedscene);
            _this5.krpano.set('hotspot[' + hotSpot.name + '].dive', hotSpot.dive);

            _this5.krpano.set('hotspot[' + hotSpot.name + '].bindvrid', hotSpot.bindVrId || hotSpot.bindvrid);
            _this5.krpano.set('hotspot[' + hotSpot.name + '].hotspottype', hotSpot.hotspottype);
            _this5.krpano.set('hotspot[' + hotSpot.name + '].areaid', hotSpot.areaId || hotSpot.areaid);
            _this5.krpano.set('hotspot[' + hotSpot.name + '].areaname', hotSpot.areaName || hotSpot.areaname);
            _this5.krpano.set('hotspot[' + hotSpot.name + '].text', hotSpot.areaName || hotSpot.areaname);
          });
        }
        this.sceneList[this.currentSceneIndex].hotspots = [];
        this.hotspotList = [];
        this.krpano.get('hotspot').getArray().forEach(function (hotspot) {
          if (hotspot.name != 'webvr_prev_scene' && hotspot.name != 'webvr_next_scene' && hotspot.name != 'vr_cursor') {
            _this5.hotspotList.push(hotspot);
            _this5.sceneList[_this5.currentSceneIndex].hotspots.push(hotspot);
            _this5.initHotspotEvent(hotspot);
          }
        });
        console.log('hotspotList', this.hotspotList);
        console.log(this.sceneList);
      }
    },

    // 通过场景名称获取关联数据
    getSceneDataByName: function getSceneDataByName(scene) {
      if (!scene) return null;
      if (this.vrSceneList) {
        var sceneItem = this.vrSceneList.find(function (item) {
          return item.name === scene.name;
        });
        return sceneItem;
      }
      return null;
    },

    //切换操作模块
    changeModule: function changeModule(module) {
      this.module = module;
    },

    //切换当前场景
    changeScene: function changeScene(scene) {
      var _this6 = this;

      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      console.log('change', scene, this.currentSceneIndex);
      console.log(this.vrSceneList);
      console.log(this.sceneList);
      if (this.currentSceneIndex == scene.index && !force) return;

      this.currentSceneIndex = scene.index;
      this.currentScene = this.sceneList[this.currentSceneIndex];
      this.krpano.call('loadscene(' + scene.name + ')');
      var currentScene = this.currentScene;
      //加载临时存储数据应用于krpano
      //自动旋转
      if (currentScene.autorotate) {
        this.krpano.set('autorotate.enabled', currentScene.autorotate.enabled);
        this.krpano.set('autorotate.waittime', currentScene.autorotate.waitTime);
      }
      if (this.autoSpinFlag) this.krpano.get('autorotate').interrupt();
      //视角
      if (currentScene.initH) this.krpano.set('view.hlookat', currentScene.initH);
      if (currentScene.initV) this.krpano.set('view.vlookat', currentScene.initV);
      if (currentScene.fovmax) this.krpano.set('view.fovmax', currentScene.fovmax);
      if (currentScene.fovmin) this.krpano.set('view.fovmin', currentScene.fovmin);
      if (currentScene.fov) this.krpano.set('view.fov', currentScene.fov);
      //热点
      // 场景所属热点指向场景的名称发生改变，flag为true，以sceneList的数据为准
      if (currentScene.hotspots && currentScene.hotspotsModifyFlag) {
        //清除原有热点
        this.krpano.get('hotspot').getArray().forEach(function (hotspot) {
          if (hotspot.name != 'webvr_prev_scene' && hotspot.name != 'webvr_next_scene' && hotspot.name != 'vr_cursor') {
            _this6.krpano.call('removehotspot(' + hotspot.name + ')');
          }
        });
        //添加存储数据热点
        currentScene.hotspots.forEach(function (hotspot) {
          _this6.krpano.call('addhotspot(' + hotspot.name + ');');
          _this6.krpano.set('hotspot[' + hotspot.name + '].ath', hotspot.ath);
          _this6.krpano.set('hotspot[' + hotspot.name + '].atv', hotspot.atv);
          _this6.krpano.set('hotspot[' + hotspot.name + '].linkedscene', hotspot.linkedscene);
          _this6.krpano.set('hotspot[' + hotspot.name + '].dive', hotspot.dive);
          _this6.krpano.get('hotspot[' + hotspot.name + ']').loadstyle(hotspot.style);
        });
      }
      //初始化模块数据
      this.initView();
      this.initHotSpot();
    },

    //设置为home页
    setWelcome: function setWelcome(index) {
      this.welcomeSceneIndex = index;
      this.toSaveFlag = true;
    },

    // 删除场景
    deleScene: function deleScene(scene) {
      // const self = this
      console.log('dele', scene, scene.name);
      this.$confirm({
        title: '删除确认',
        onOk: function onOk() {
          // console.log(self.krpano.get('scene'))
          // self.krpano.get('scene').removearrayitem(scene.name)
          self.krpano.set('scene[' + scene.name + '].name', null);
          // console.log('sceneList after dele', self.sceneList, self.currentScene)
          if (self.currentSceneIndex === scene.index) {
            // 删除的是当前场景
            self.currentSceneIndex = -1;
            self.currentScene = null;
            if (self.sceneList.length > 0) {
              self.changeScene(self.sceneList[0]);
            }
          } else {
            self.currentSceneIndex = self.currentScene ? self.currentScene.index : -1;
          }
          self.toSaveFlag = true;
        },
        onCancel: function onCancel() {}
      });
    },

    // 保存
    save2: function save2() {
      var _this7 = this;

      if (!this.toSaveFlag) return;
      if (this.requesting) {
        this.$message.warning('保存中，请稍后再试');
        return;
      }
      this.requesting = true;
      var data = [];
      console.log('sceneList', this.sceneList);
      this.sceneList.forEach(function (scene) {
        var sceneData = {
          vrIndex: scene.index,
          name: scene.name,
          welcomeFlag: scene.index == _this7.welcomeSceneIndex,
          autorotate: scene.autorotate ? scene.autorotate : {
            enabled: false,
            waitTime: 1.5
          },
          fov: scene.fov ? scene.fov : '80',
          fovmax: scene.fovmax ? scene.fovmax : '120',
          fovmin: !isNaN(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default()(scene.fovmin)) ? scene.fovmin : '50',
          initH: scene.initH ? scene.initH : '0',
          initV: scene.initV ? scene.initV : '0',

          imageurl: scene.imageurl,
          previewurl: scene.previewurl,
          thumburl: scene.thumburl,
          imageType: scene.imagetype || scene.imageType,
          images: scene.images
          // 没有加载过的场景不会有hotspots，用原有的数据hotSpots代替
        };if (scene.hotspots || scene.hotSpots) {
          var hotSpotsData = scene.hotspots || scene.hotSpots;
          var hotSpots = [];
          hotSpotsData.forEach(function (hotspot) {
            hotSpots.push({
              ath: hotspot.ath,
              atv: hotspot.atv,
              name: hotspot.name,
              linkedscene: hotspot.linkedscene,
              style: hotspot.style,
              dive: hotspot.dive,
              // bindVrId从Ef对象里拿出来是小写的
              bindVrId: hotspot.bindvrid || hotspot.bindVrId,
              areaId: hotspot.areaid || hotspot.areaId,
              areaName: hotspot.areaname || hotspot.areaName,
              hotspottype: hotspot.hotspottype
            });
          });
          sceneData.hotSpots = hotSpots;
        }
        data.push(sceneData);
      });
      var actionMethod = '';
      var params = {};
      if (this.vrData) {
        actionMethod = this.$api.updateVr;
        params = {
          id: this.vrData.id,
          areaLevel: this.vrData.areaLevel || this.currentLand.areaLevel,
          vrSceneList: data
        };
      } else if (this.currentLand) {
        actionMethod = this.$api.addVr;

        params = {
          areaId: this.currentLand.id,
          areaLevel: this.currentLand.areaLevel,
          vrSceneList: data
        };
      }
      if (!actionMethod) return;
      // console.log('params', params)
      actionMethod(params).then(function (res) {
        self.$message.success('操作成功');
        self.requesting = false;
        self.toSaveFlag = false;
        if (self.currentLand && self.currentLand.vrId) {
          self.getVrByLand(self.currentLand);
        } else if (res.id) {
          self.getVrByLand({
            vrId: res.id
          });
        }
      }).catch(function (err) {
        console.log(err);
        self.requesting = false;
      });
    },

    // 本地node.js保存到xml
    save: function save() {
      var _this8 = this;

      if (!this.toSaveFlag) return;
      if (this.requesting) {
        alert('保存中，请稍后再试');
        return;
      }
      this.requesting = true;
      var data = [];
      console.log('sceneList', this.sceneList);
      this.sceneList.forEach(function (scene) {
        var sceneData = {
          index: scene.index,
          name: scene.name,
          welcomeFlag: scene.index == _this8.welcomeSceneIndex,
          autorotate: scene.autorotate ? scene.autorotate : null,
          fov: scene.fov ? scene.fov : null,
          fovmax: scene.fovmax ? scene.fovmax : null,
          fovmin: !isNaN(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default()(scene.fovmin)) ? scene.fovmin : null,
          initH: scene.initH ? scene.initH : null,
          initV: scene.initV ? scene.initV : null,

          // previewurl: scene.previewurl || 'previewurl',
          // imageurl: scene.imageurl || 'imageUrl',
          // thumburl: scene.thumburl || 'thumburl',
          imageType: 2,
          images: [{
            imageurl: 'imageurl',
            side: 'u'
          }]
        };
        if (scene.hotspots) {
          var hotSpots = [];
          scene.hotspots.forEach(function (hotspot) {
            hotSpots.push({
              ath: hotspot.ath,
              atv: hotspot.atv,
              name: hotspot.name,
              linkedscene: hotspot.linkedscene,
              style: hotspot.style,
              dive: hotspot.dive
              // 其他数据
              // desc: hotspot.desc || '',
              // land: hotspot.land,
              // purchased: hotspot.purchased,
              // deadline: hotspot.deadline || '',
              // person: hotspot.person || ''
            });
          });
          sceneData.hotSpots = hotSpots;
        }
        data.push(sceneData);
      });
      console.log('params', data);
      fetch('/server/save', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data)
      }).then(function (res) {
        _this8.requesting = false;
        if (res.status === 200) {
          res.text().then(function (resText) {
            _this8.toSaveFlag = false;
            alert(resText);
          });
        } else {
          alert('系统异常');
        }
      }, function () {
        _this8.requesting = false;
        alert('系统异常');
      });
    },

    //预览
    preview: function preview() {
      if (this.currentLand && this.currentLand.vrId) {
        window.open('../static/tour.html?id=' + this.currentLand.vrId);
      } else {
        this.$message.warning('当前地块暂无vr');
      }
    },

    //显示修改场景弹窗
    showModifyScene: function showModifyScene(scene) {
      console.log('modify', scene);
      this.modalVisible = true;
      this.toModifyScene = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, scene, {
        name: scene.name,
        index: scene.index
        // this.showModifySceneFlag = true

      });this.$refs.editScene.setFileList({
        imageurl: scene.imageurl,
        previewurl: scene.previewurl,
        thumburl: scene.thumburl,
        sceneName: scene.name,
        imageType: scene.imagetype,
        images: scene.images
      });
    },

    //修改场景名称
    modifySceneName: function modifySceneName() {
      var _this9 = this;

      if (!this.sceneNameValid) return;
      //判断是否重复
      var repeatFlag = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.sceneList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var scene = _step.value;

          if (scene.name == this.toModifyScene.name) {
            repeatFlag = true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (repeatFlag) {
        alert('场景名称重复');
        return;
      }
      //修改场景名称（相关联的热点，当前场景scene名称也需修改）
      var oldName = this.sceneList[this.toModifyScene.index].name.toString();
      var newName = this.toModifyScene.name.toString();
      //修改krpano场景对象名称
      this.krpano.get('scene').renameItem(oldName, newName);
      this.sceneList[this.toModifyScene.index].name = newName;
      //修改krpano热点指向场景名称
      this.sceneList.forEach(function (scene) {
        if (scene.hotspots && scene.index != _this9.toModifyScene.index) {
          scene.hotspots.forEach(function (hotspot) {
            if (hotspot.linkedscene == oldName) {
              hotspot.linkedscene = newName;
              scene.hotspotsModifyFlag = true;
              if (scene.index == _this9.currentSceneIndex) _this9.krpano.set('hotspot[' + hotspot.name + '].linkedscene', newName);
            }
          });
        }
      });
      this.showModifySceneFlag = false;
      this.toSaveFlag = true;
    },

    //关闭修改场景弹窗
    closeModifySceneName: function closeModifySceneName() {
      this.showModifySceneFlag = false;
    },

    //设为初始视角
    setDefaultView: function setDefaultView() {
      var fov = Math.round(this.krpano.get('view.fov'));
      this.initFov = fov;
      this.sceneList[this.currentSceneIndex].fov = fov;
      this.sceneList[this.currentSceneIndex].initH = this.krpano.get('view.hlookat');
      this.sceneList[this.currentSceneIndex].initV = this.krpano.get('view.vlookat');
      this.toSaveFlag = true;
    },

    //自动旋转变更
    updatedAutoSpin: function updatedAutoSpin() {
      this.krpano.set('autorotate.enabled', this.autoSpinFlag);
      this.krpano.set('autorotate.waittime', this.autoSpinWaitingTime);
      if (this.autoSpinFlag) this.krpano.get('autorotate').interrupt();
      this.sceneList[this.currentSceneIndex].autorotate = {
        enabled: this.autoSpinFlag,
        waitTime: Number(this.autoSpinWaitingTime)
      };
      this.toSaveFlag = true;
    },

    //视角条拖动
    moveInitFov: function moveInitFov() {
      if (this.initFovMoveFlag) {
        var slider = document.querySelector('.view-top-slider');
        var left = window.event.clientX - slider.offsetLeft;
        if (left < Math.round(this.minFov * slider.clientWidth / 180)) {
          if (left < -6) this.stopMoveInitFov();
          left = Math.round(this.minFov * slider.clientWidth / 180);
        } else if (left > Math.round(this.maxFov * slider.clientWidth / 180)) {
          if (left > slider.clientWidth + 6) this.stopMoveInitFov();
          left = Math.round(this.maxFov * slider.clientWidth / 180);
        }
        this.initFovLeft = left;
        this.krpano.set('view.fov', this.initFov);
        this.sceneList[this.currentSceneIndex].fov = this.initFov;
        this.toSaveFlag = true;
      }
    },
    startMoveInitFov: function startMoveInitFov() {
      this.initFovMoveFlag = true;
      this.moveInitFov();
    },
    stopMoveInitFov: function stopMoveInitFov() {
      this.initFovMoveFlag = false;
    },

    //热点事件初始化
    initHotspotEvent: function initHotspotEvent(hotspot) {
      var thisVue = this;
      hotspot.ondown = function () {
        thisVue.selectedHotspot = hotspot;
        thisVue.selectHotspot();
        thisVue.isHotspotMoving = true;
      };
      hotspot.onover = function () {
        thisVue.selectedHotspot = hotspot;
      };
      hotspot.onout = function () {
        thisVue.selectedHotspot = {};
      };
      hotspot.onclick = function () {
        // thisVue.currentHotspot = thisVue.selectedHotspot
        thisVue.showHotspotDetail(thisVue.selectedHotspot);
        thisVue.showHotspotMsg();
      };
      // hotspot.onloaded = function () {
      // thisVue.addHotSpotTip()
      // }
    },

    //热点坐标与鼠标坐标偏移计算
    selectHotspot: function selectHotspot() {
      this.krpano.call('screentosphere(mouse.x, mouse.y, mouseath, mouseatv);');
      this.selectedHotspot.athDis = this.selectedHotspot.ath - this.krpano.get('mouseath');
      this.selectedHotspot.atvDis = this.selectedHotspot.atv - this.krpano.get('mouseatv');
    },

    //热点移动
    moveHotspot: function moveHotspot() {
      if (this.isHotspotMoving) {
        this.krpano.call('screentosphere(mouse.x, mouse.y, mouseath, mouseatv);');
        this.krpano.set('hotspot[' + this.selectedHotspot.name + '].ath', this.krpano.get("mouseath") + this.selectedHotspot.athDis);
        this.krpano.set('hotspot[' + this.selectedHotspot.name + '].atv', this.krpano.get("mouseatv") + this.selectedHotspot.atvDis);
      }
    },

    //显示热点详情
    showHotspotDetail: function showHotspotDetail(hotspotItem) {
      console.log('hotspotItem', hotspotItem);
      this.currentHotspot = hotspotItem ? hotspotItem : {
        style: this.hotspotStyleList[0].name,
        linkedscene: this.sceneListExceptCurrent.length > 0 ? this.sceneListExceptCurrent[0].name : '',
        dive: true,
        hotspottype: '1'
      };
      this.showHotspotDetailFlag = true;
    },

    //隐藏热点详情
    hideHotspotDetail: function hideHotspotDetail() {
      this.showHotspotDetailFlag = false;
    },

    //选择热点图标样式
    selectHotspotStyle: function selectHotspotStyle(name) {
      this.currentHotspot.style = name;
    },

    //选择切换场景热点目标场景
    selectHotspotLinkedScene: function selectHotspotLinkedScene(name) {
      this.currentHotspot.linkedscene = name;
    },

    // 切换热点的类型
    handleHotspotTypeChange: function handleHotspotTypeChange(value) {
      if (value == 1) {} else if (value == 2) {
        this.currentHotspot.linkedscene = '';
      }
    },

    //保存当前热点变动
    saveCurrentHotspot: function saveCurrentHotspot() {
      // console.log('currentHotspot', this.currentHotspot, this.currentHotspot.linkedscene, this.currentHotspot.style)
      if (!this.currentHotspot.name) {
        // 计算中间位置的球面坐标
        this.krpano.set('halfHeight', this.krpano.get('stageheight') / 2);
        this.krpano.set('halfWidth', this.krpano.get('stagewidth') / 2);
        this.krpano.call('screentosphere(halfWidth,halfHeight,init_h,init_v);');
        var init_h = this.krpano.get('init_h');
        var init_v = this.krpano.get('init_v');
        //添加热点
        var name = 'spot' + new Date().getTime();
        this.krpano.call('addhotspot(' + name + ');');
        this.krpano.get('hotspot[' + name + ']').loadstyle(this.currentHotspot.style);
        this.krpano.set('hotspot[' + name + '].ath', init_h);
        this.krpano.set('hotspot[' + name + '].atv', init_v);
        this.krpano.set('hotspot[' + name + '].linkedscene', this.currentHotspot.linkedscene);
        this.krpano.set('hotspot[' + name + '].dive', this.currentHotspot.dive);
      } else {
        // var linkedscene = this.currentHotspot.linkedscene
        var sceneName = this.currentHotspot.linkedscene;
        this.krpano.get('hotspot[' + this.currentHotspot.name + ']').loadstyle(this.currentHotspot.style);
        this.krpano.set('hotspot[' + this.currentHotspot.name + '].linkedscene', sceneName);
      }
      this.initHotSpot();
      this.showHotspotDetailFlag = false;
      this.toSaveFlag = true;
    },

    //删除热点
    deleteCurrentHotspot: function deleteCurrentHotspot() {
      // console.log(this.currentHotspot)
      this.krpano.call('removehotspot(' + this.currentHotspot.name + ')');
      this.currentScene.hotspots = this.currentScene.hotspots.filter(function (hotspot) {
        return hotspot.name !== self.currentHotspot.name;
      });
      // if(this.currentHotspot.bindvrid) {
      //   var hotSpotData = this.currentScene.hotSpots.find(hotSpot => {
      //     return hotSpot.name === this.currentHotspot.name
      //   })
      //   if(hotSpotData) {
      //     this.$api.deleteVrHotSpots([hotSpotData.id]).then(res => {
      //     })
      //   }
      // }
      this.initHotSpot();
      this.showHotspotDetailFlag = false;
      this.toSaveFlag = true;
    },

    // 热点点击事件，显示弹框
    showHotspotMsg: function showHotspotMsg() {
      var _this10 = this;

      // console.log('currentHotspot', this.currentHotspot)
      // console.log(this.hotspotList, this.vrSceneList)
      this.chooseVisible = true;

      var sceneData = this.getSceneDataByName(this.currentScene);
      if (sceneData) {
        var hotSpots = sceneData.hotSpots;
        var hotSpotData = hotSpots.find(function (item) {
          return item.name === _this10.currentHotspot.name;
        });
        if (hotSpotData && hotSpotData.bindVrId) {
          this.$nextTick(function () {
            _this10.$refs.choose.initForm({
              bindVrId: hotSpotData.bindVrId,
              areaName: hotSpotData.areaName
            });
          });
        }
      }
    },


    // 热点选择土地，点击确认
    chooseConfirm: function chooseConfirm(value) {
      var _this11 = this;

      // warnnn 可能新建了场景
      this.chooseVisible = false;
      // console.log(this.vrSceneList, this.currentSceneIndex)
      var sceneData = this.getSceneDataByName(this.currentScene);
      if (!sceneData) return;
      var actionMethod = '';
      var params = {};
      var hotSpotData = sceneData.hotSpots.find(function (item) {
        return item.name === _this11.currentHotspot.name;
      });
      if (hotSpotData) {
        actionMethod = this.$api.updateVrHotSpots;
        params = {
          areaId: value.areaId,
          areaLevel: value.areaLevel,
          sceneId: sceneData.id,
          bindVrId: value.value,
          id: hotSpotData.id
        };
      } else {
        actionMethod = this.$api.addVrHotSpots;
        params = {
          areaId: value.areaId,
          areaLevel: value.areaLevel,
          sceneId: sceneData.id,
          bindVrId: value.value,
          ath: this.currentHotspot.ath,
          atv: this.currentHotspot.atv,
          name: this.currentHotspot.name,
          linkedscene: this.currentHotspot.linkedscene,
          style: this.currentHotspot.style,
          dive: this.currentHotspot.dive
        };
      }
      actionMethod(params).then(function (res) {
        self.krpano.set('hotspot[' + self.currentHotspot.name + '].areaid', value.areaId);
        self.krpano.set('hotspot[' + self.currentHotspot.name + '].areaname', value.areaName);
        self.krpano.set('hotspot[' + self.currentHotspot.name + '].bindvrid', value.value);
        self.$message.success('操作成功');
        if (self.currentLand && self.currentLand.vrId) {
          // warnnnn
          self.getVrByLand(self.currentLand);
        }
      });
    },

    // 当前地块改变
    changeLand: function changeLand(land) {
      this.currentLand = land;
      this.toSaveFlag = false;
      this.getVrByLand(land);
    },

    // 获取土地关联vr
    getVrByLand: function getVrByLand(land) {
      var _this12 = this;

      this.removeAllScene();
      if (!land.vrId) {
        return;
      }
      this.$api.getVr({
        id: land.vrId
      }).then(function (res) {
        if (res.content.length > 0) {
          _this12.vrData = res.content[0];
          _this12.vrSceneList = res.content[0].vrSceneList;
          _this12.addAllScene(_this12.vrSceneList);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    // 通过vrid跳转到对应土地
    toLandByVrId: function toLandByVrId(vrId) {
      this.chooseVisible = false;
      this.$refs.land.toLandByVrId(vrId);
    }
  }
});

/***/ }),

/***/ 832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LandDetail__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LandDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LandDetail__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var self = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LandDetail: __WEBPACK_IMPORTED_MODULE_1__components_LandDetail___default.a
  },
  props: {
    // currentLand: {
    //   type: Object
    // }
  },
  data: function data() {
    return {
      // 当前地块的下级地块，土地列表
      landList: [],
      detailVisible: false,
      // 当前地块
      currentLand: null,
      // 当前选择的下级地块
      currLowerLand: null,
      // 存储历史上级地块
      historyLand: []
    };
  },
  created: function created() {
    self = this;
  },
  mounted: function mounted() {
    this.getPageManor(true);
  },

  computed: {
    // 添加地块按钮文字
    addLandBtnText: function addLandBtnText() {
      var level = '';
      if (this.currentLand) {
        switch (this.currentLand.areaLevel) {
          case 1:
            level = '二级';break;
          case 2:
            level = '三级';break;
          case 3:
            level = '四级';break;
        }
      } else {
        level = '一级';
      }
      return '\u6DFB\u52A0' + level + '\u5730\u5757';
    }
  },
  methods: {
    // 增加土地
    showLandDetailModal: function showLandDetailModal(item) {
      var _this = this;

      console.log('item', item);
      this.detailVisible = true;
      if (item) {
        this.currLowerLand = item;
        this.$nextTick(function () {
          item.areaName = item.manorName || item.areaName;
          _this.$refs.detail.initForm(item);
        });
      } else {
        this.currLowerLand = null;
      }
    },

    // 根据级别获取土地列表
    getLandListByLevel: function getLandListByLevel(level, land) {
      console.log('get', level, land);
      if (level == 1) {
        this.getPageManor();
      } else if (level == 2) {
        this.getSecondArea(land);
      } else if (level == 3) {
        this.getThreeArea(land);
      } else if (level == 4) {
        this.getFourArea(land);
      } else {
        this.landList = [];
      }
    },

    // 前往上级
    toHigherLand: function toHigherLand() {
      console.log('history', this.historyLand);
      if (this.historyLand.length > 0) {
        this.currentLand = this.historyLand.pop();
        self.$emit('change-land', this.currentLand);
        this.getLandListByLevel(this.currentLand.areaLevel + 1, this.currentLand);
      }
    },

    // 前往下级
    toLowerLand: function toLowerLand() {
      console.log('tolower', this.currLowerLand);
      this.detailVisible = false;
      if (this.currLowerLand) {
        this.historyLand.push(this.currentLand);
        this.currentLand = this.currLowerLand;
        self.$emit('change-land', this.currentLand);
        this.getLandListByLevel(this.currentLand.areaLevel + 1, this.currentLand);
      }
    },

    // 删除土地
    handleLandDelete: function handleLandDelete() {
      this.detailVisible = false;
      var actionMethod = '';
      var _currLowerLand = this.currLowerLand,
          areaLevel = _currLowerLand.areaLevel,
          id = _currLowerLand.id;

      if (areaLevel == 2) {
        actionMethod = this.$api.deleteSecondArea;
      } else if (areaLevel == 3) {
        actionMethod = this.$api.deleteThreeArea;
      } else if (areaLevel == 4) {
        actionMethod = this.$api.deleteFourArea;
      }
      if (actionMethod) {
        var params = [id];
        actionMethod(params).then(function (res) {
          self.$message.success('删除成功');
          self.getLandListByLevel(self.currentLand.areaLevel, self.currentLand);
        });
      }
    },

    // 新增/修改土地
    handleLandSubmit: function handleLandSubmit(value) {
      console.log('submit', value);
      this.detailVisible = false;

      var actionMethod = '';
      var params = {};
      // 有当前下级地块，为修改
      if (this.currLowerLand) {
        var areaLevel = this.currLowerLand.areaLevel;

        if (areaLevel === 1) {
          actionMethod = this.$api.updateManor;
          params = {
            id: this.currLowerLand.id,
            manorName: value.areaName
          };
        } else if (areaLevel === 2) {
          actionMethod = this.$api.updateSecondArea;
          params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            id: this.currLowerLand.id
          }, value);
        } else if (areaLevel === 3) {
          actionMethod = this.$api.updateThreeArea;
          params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            id: this.currLowerLand.id
          }, value);
        } else if (areaLevel === 4) {
          actionMethod = this.$api.updateFourArea;
          params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            id: this.currLowerLand.id
          }, value);
        }
        if (actionMethod) {
          actionMethod(params).then(function (res) {
            self.$message.success('修改成功');
            self.getLandListByLevel(self.currLowerLand.areaLevel, self.currentLand);
          });
        }
      } else {
        if (this.currentLand) {
          if (this.currentLand.areaLevel === 1) {
            actionMethod = this.$api.addSecondArea;
            params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value, {
              parentId: this.currentLand.id
            });
          } else if (this.currentLand.areaLevel === 2) {
            actionMethod = this.$api.addThreeArea;
            params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value, {
              parentId: this.currentLand.id
            });
          } else if (this.currentLand.areaLevel === 3) {
            actionMethod = this.$api.addFourArea;
            params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value, {
              parentId: this.currentLand.id
            });
          }
        } else {
          // 没有当前选择地块，为一级地块
          actionMethod = this.$api.addManor;
          params = {
            manorName: value.areaName
          };
        }
        if (actionMethod) {
          actionMethod(params).then(function (res) {
            if (res) {
              self.$message.success('添加地块成功');
              self.getLandListByLevel(self.currentLand ? self.currentLand.areaLevel + 1 : 1, self.currentLand);
            }
          });
        }
      }
    },

    // 通过vrid跳转到对应土地
    toLandByVrId: function toLandByVrId(vrId) {
      var item = this.landList.find(function (item) {
        return item.vrId === vrId;
      });
      if (item) {
        this.currLowerLand = item;
        this.toLowerLand();
      }
    },

    // 下载土地excel
    downloadManor: function downloadManor() {
      this.$api.exportManor().then(function (res) {
        fileDownload(res, '土地.xls');
      }).catch(function (err) {
        console.log(err);
      });
    },


    // 获取土地列表
    getPageManor: function getPageManor(firstTime) {
      this.$api.getManor({
        page: 1,
        size: 10
      }).then(function (res) {
        if (res.content.length > 0) {
          self.currentLand = res.content[0];
          if (firstTime) {
            self.$emit('change-land', self.currentLand);
          }
          self.getLandListByLevel(self.currentLand.areaLevel + 1, self.currentLand);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    // 获取二级地块
    getSecondArea: function getSecondArea(land) {
      // const self = this
      this.$api.getSecondArea({
        page: 1,
        size: 10,
        parentId: land.id
      }).then(function (res) {
        if (res.content) {
          self.landList = res.content;
        }
      });
    },

    // 获取三级地块
    getThreeArea: function getThreeArea(land) {
      this.$api.getThreeArea({
        page: 1,
        size: 10,
        parentId: land.id
      }).then(function (res) {
        if (res.content) {
          self.landList = res.content;
        }
      });
    },

    // 获取四级地块
    getFourArea: function getFourArea(land) {
      this.$api.getFourArea({
        page: 1,
        size: 10,
        parentId: land.id
      }).then(function (res) {
        if (res.content) {
          self.landList = res.content;
        }
      });
    }
  }
});

/***/ }),

/***/ 833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

var self = null;
var pages = [{
  path: '/farmPages/farm/index',
  name: '我的庄园'
}, {
  path: '/bookingPages/index',
  name: '订房'
}, {
  path: '/orderingPages/index',
  name: '订餐'
}, {
  path: '/shopPages/shop/tabbar',
  name: '购物'
}, {
  path: '/pages/story/index',
  name: '品牌故事'
}, {
  path: '/farmPages/farm/monitor',
  name: '实时视频'
}];
var getNameByPath = function getNameByPath(path) {
  var item = pages.find(function (item) {
    return item.path === path;
  });
  return item ? item.name : '';
};
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // vrId
      vrId: '',
      //  vr数据
      vrData: null,
      // 接口返回scene list
      vrSceneList: [],
      //krpano对象
      krpano: document.querySelector('#krpanoSWFObject'),
      //场景列表
      sceneList: [],
      //当前场景序号
      currentSceneIndex: -1,
      // 当前场景
      currentScene: null,
      //欢迎页场景序号
      welcomeSceneIndex: -1,
      // 土地占位图
      placeholderImg: 'https://vr.gdyfpt.com/file/pic/20201026181417209173.png',

      menus: [{
        name: '我要认购',
        url: '/farmPages/farm/purchaseLand',
        action: 'navigateTo'
      }, {
        name: '订餐',
        url: '/orderingPages/index',
        action: 'navigateTo'
      }, {
        name: '订房',
        url: '/bookingPages/index',
        action: 'navigateTo'
      }, {
        name: '购物',
        url: '/shopPages/shop/tabbar',
        action: 'navigateTo'
      }, {
        name: '实时视频',
        url: '/farmPages/farm/monitor',
        action: 'navigateTo'
      }]
    };
  },
  created: function created() {
    var _this = this;

    // console.log('created', this.$route)
    self = this;
    window.onresize = function () {
      _this.getRem(7.5);
    };
    // if(this.$route.query.vrId) {
    //   this.vrId = this.$route.query.vrId
    // }
    this.vrId = 60;
  },

  computed: {},
  mounted: function mounted() {
    document.title = '智慧油茶';

    this.getRem(7.5);
    embedpano({
      // 该文件仅用于Flashplayer，而仅使用HTML5时，则不需要此文件。
      swf: "/static/tour.swf",
      xml: "/static/tour2.xml",
      target: "pano",
      html5: "auto",
      mobilescale: 1.0,
      // 布尔设置。设置为true时，来自html url的所有查询参数将作为变量传递给查看器。
      passQueryParameters: true,
      onready: this.onready
    });

    // 侦听场景切换
    window['onnewscene'] = function (val) {
      self.onnewscene(val);
    };
  },

  watch: {},
  methods: {
    menuBtnClick: function menuBtnClick(item) {
      console.log('item', item);

      var action = item.action;
      var url = item.url;

      switch (action) {
        case 'switchTab':
          uni.switchTab({
            url: url
          });
          break;
        case 'reLaunch':
          uni.reLaunch({
            url: url
          });
          break;
        case 'navigateBack':
          uni.navigateBack({
            delta: 1
          });
          break;
        default:
          uni[action]({
            url: url
          });
          break;
      }
    },
    getRem: function getRem(prem) {
      var html = document.getElementsByTagName("html")[0];
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = oWidth / prem + "px";
    },

    //入口js文件已将此函数定义到window，krpano加载完成后调用
    onready: function onready() {
      console.log('myready');
      this.krpano = document.querySelector('#krpanoSWFObject');

      //初始化场景
      this.sceneList = this.krpano.get('scene').getArray();

      //热点移动事件初始化
      var thisVue = this;
      var pano = document.querySelector('#pano');

      if (this.vrId) {
        this.getVrByLand({
          vrId: this.vrId
        });
      }
    },

    // 加载全部场景
    addAllScene: function addAllScene(list) {
      var _this2 = this;

      if (!list) return;
      list.forEach(function (item, index) {
        var imageXmlStr = '';
        var previewXmlStr = item.previewurl ? '<preview url="' + item.previewurl + '"/>' : '';
        if (item.imageType == 1) {
          imageXmlStr = '\n          <image>\n              <sphere url="' + item.imageurl + '" />\n          </image>';
        } else if (item.imageType == 2) {
          var images = item.images ? item.images : [];
          var prefix = '';
          if (images.length > 0) {
            prefix = images[0].imageurl.split('_')[0];
          }
          imageXmlStr = '\n          <image type="CUBE">\n            <cube url="' + (prefix + '_%s.jpg') + '"/>\n          </image>';
        }
        _this2.krpano.call('addscene(' + item.name + ');');
        // 场景的title即为热点title文字，或热点的text
        _this2.krpano.set('scene[' + item.name + '].title', item.name);
        _this2.krpano.set('scene[' + item.name + '].imageurl', item.imageurl);
        _this2.krpano.set('scene[' + item.name + '].thumburl', item.thumburl);
        _this2.krpano.set('scene[' + item.name + '].images', images);
        _this2.krpano.set('scene[' + item.name + '].imagetype', item.imageType);
        // this.krpano.set('scene[' + item.name + '].welcomeFlag', item.welcomeFlag)
        _this2.krpano.set('scene[' + item.name + '].content', '\n          <view hlookat="' + (item.initH || 0) + '" vlookat="' + (item.initV || 0) + '" fovtype="MFOV" fov="' + item.fov + '" fovmin="' + item.fovmin + '" fovmax="' + item.fovmax + '" limitview="auto"/>\n          ' + previewXmlStr + imageXmlStr + ('\n          <autorotate enabled="' + (item.autorotate ? item.autorotate.enabled || false : false) + '" waittime="' + (item.autorotate ? item.autorotate.waitTime : 0) + '" accel="1.0" speed="5.0" horizon="0.0"/>\n          '));
        // addhotspot只在有场景时生效
      });

      // 同步数据到sceneList
      for (var x in this.sceneList) {
        var sceneData = list[x];
        if (sceneData) {
          // this.sceneList[x] = Object.assign(sceneData, this.sceneList[x])
          for (var column in sceneData) {
            if (!this.sceneList[x].hasOwnProperty(column)) {
              this.sceneList[x][column] = sceneData[column];
            }
          }
        }
      }

      // 加载初始化场景
      if (this.currentSceneIndex == -1 && this.sceneList) {
        var startIndex = this.sceneList.findIndex(function (item) {
          return item.welcomeFlag === 'true' || item.welcomeFlag === true;
        });
        if (startIndex !== -1) {
          this.welcomeSceneIndex = startIndex;
          this.changeScene(this.sceneList[startIndex], true);
        } else if (this.sceneList.length > 0) {
          // 没有设置初始场景，显示第一个
          this.changeScene(this.sceneList[0], true);
        }
      }
      // console.log('list', this.sceneList)
    },

    // 清除所有场景
    removeAllScene: function removeAllScene() {
      var _this3 = this;

      var sceneNames = this.krpano.get('scene').getArray().map(function (scene) {
        return scene.name;
      });
      // console.log('remove', sceneNames)
      // console.log(this.sceneList, this.sceneList.length)
      sceneNames.forEach(function (name) {
        _this3.krpano.set('scene[' + name + '].name', null);
      });
      // console.log(this.sceneList, this.sceneList.length)
      this.vrData = null;

      this.vrSceneList = [];
      this.currentSceneIndex = -1;
      this.welcomeSceneIndex = -1;
      // this.krpano.call('loadscene(二级地2)', null, 'REMOVESCENES');
    },

    // 侦听场景切换
    onnewscene: function onnewscene(sceneName) {
      // console.log('onnewscene', sceneName)
      if (this.currentScene.name != sceneName) {
        this.currentScene = this.sceneList.find(function (scene) {
          return scene.name == sceneName;
        });
        this.currentSceneIndex = this.currentScene ? this.currentScene.index : -1;
      }
      this.initHotSpot();
    },

    //根据krpano参数初始化视角和热点模块数据
    initView: function initView() {
      //初始化视角参数
      this.autoSpinWaitingTime = this.krpano.get('autorotate.waittime');
      this.autoSpinFlag = this.krpano.get('autorotate.enabled');
      this.minFov = this.krpano.get('view.fovmin');
      this.maxFov = this.krpano.get('view.fovmax');
      this.initFov = this.krpano.get('view.fov');
    },

    //热点初始化
    initHotSpot: function initHotSpot() {
      var _this4 = this;

      // adddhotspot之后热点并不会自动添加到场景中的hotspots中去，手动添加
      // hotspot的keep默认为false，切换场景后自动消失
      console.log('initHotSpot', this.currentScene);
      if (this.currentScene) {
        // 添加热点
        var hotSpots = this.currentScene.hotspots || this.currentScene.hotSpots;
        if (hotSpots) {
          hotSpots.forEach(function (hotSpot) {
            var linkedscene = hotSpot.linkedscene;
            var hotspotName = getNameByPath(hotSpot.linkedscene);
            _this4.krpano.call('addhotspot(' + hotSpot.name + ');');
            _this4.krpano.get('hotspot[' + hotSpot.name + ']').loadstyle(hotSpot.style);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].ath', hotSpot.ath);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].atv', hotSpot.atv);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].linkedscene', linkedscene);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].dive', hotSpot.dive);

            _this4.krpano.set('hotspot[' + hotSpot.name + '].bindvrid', hotSpot.bindVrId || hotSpot.bindvrid);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].areaid', hotSpot.areaId || hotSpot.areaid);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].hotspottype', hotSpot.hotspottype);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].areaname', hotSpot.areaName || hotSpot.areaname);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].text', hotspotName);
          });
        }
        if (this.sceneList[this.currentSceneIndex]) {
          this.sceneList[this.currentSceneIndex].hotspots = [];
        }
        this.krpano.get('hotspot').getArray().forEach(function (hotspot) {
          if (hotspot.name != 'webvr_prev_scene' && hotspot.name != 'webvr_next_scene' && hotspot.name != 'vr_cursor') {
            // console.log(this.currentSceneIndex, this.sceneList.length, this.sceneList)
            if (_this4.sceneList[_this4.currentSceneIndex]) {
              _this4.sceneList[_this4.currentSceneIndex].hotspots.push(hotspot);
            }
            _this4.initHotspotEvent(hotspot);
          }
        });
        // console.log(this.sceneList)
      }
    },

    // 通过场景名称获取关联数据
    getSceneDataByName: function getSceneDataByName(scene) {
      if (!scene) return null;
      if (this.vrSceneList) {
        var sceneItem = this.vrSceneList.find(function (item) {
          return item.name === scene.name;
        });
        return sceneItem;
      }
      return null;
    },

    //切换操作模块
    changeModule: function changeModule(module) {
      this.module = module;
    },

    //切换当前场景
    changeScene: function changeScene(scene) {
      var fisheye = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // console.log('change', scene, this.currentSceneIndex)
      // console.log(this.vrSceneList)
      // console.log(this.sceneList)
      if (this.currentSceneIndex == scene.index) return;

      this.currentSceneIndex = scene.index;
      this.currentScene = this.sceneList[this.currentSceneIndex];
      this.krpano.call('loadscene(' + scene.name + ')');
      var currentScene = this.sceneList[this.currentSceneIndex];
      //加载临时存储数据应用于krpano
      //自动旋转
      if (currentScene.autorotate) {
        this.krpano.set('autorotate.enabled', currentScene.autorotate.enabled);
        this.krpano.set('autorotate.waittime', currentScene.autorotate.waitTime);
      }
      if (this.autoSpinFlag) this.krpano.get('autorotate').interrupt();
      //视角
      // if (currentScene.initH) this.krpano.set('view.hlookat', currentScene.initH)
      // if (currentScene.initV) this.krpano.set('view.vlookat', currentScene.initV)
      // if (currentScene.fovmax) this.krpano.set('view.fovmax', currentScene.fovmax)
      // if (currentScene.fovmin) this.krpano.set('view.fovmin', currentScene.fovmin)
      // if (currentScene.fov) this.krpano.set('view.fov', currentScene.fov)


      if (currentScene.fovmin) this.krpano.set('view.fovmin', currentScene.fovmin);
      if (fisheye) {
        this.krpano.set('view.fisheye', '1.0');
        this.krpano.set('view.stereographic', true);
        this.krpano.set('view.fovmax', 150);
        this.krpano.set('view.hlookat', currentScene.initH ? 180 + Number(currentScene.initH) : 180);
        this.krpano.set('view.vlookat', 90);
        this.krpano.set('view.fov', 150);

        this.krpano.call('setfish(' + currentScene.initH + ', ' + currentScene.initV + ', ' + currentScene.fov + ')');
      } else {
        this.krpano.set('view.fisheye', '0.0');
        this.krpano.set('view.stereographic', false);
        if (currentScene.fovmax) this.krpano.set('view.fovmax', currentScene.fovmax);
        if (currentScene.initH) this.krpano.set('view.hlookat', currentScene.initH);
        if (currentScene.initV) this.krpano.set('view.vlookat', currentScene.initV);
        if (currentScene.fov) this.krpano.set('view.fov', currentScene.fov);
      }

      //初始化模块数据
      this.initView();
      // this.initHotSpot()
    },

    //热点事件初始化
    initHotspotEvent: function initHotspotEvent(hotspot) {
      hotspot.onclick = function () {
        if (hotspot.linkedscene) {
          uni.navigateTo({
            url: hotspot.linkedscene
          });
        }
      };
    },

    // 获取土地关联vr
    getVrByLand: function getVrByLand(land) {
      var _this5 = this;

      if (!land.vrId) {
        this.$message.warning('该地块暂无vr');
        return;
      }
      this.removeAllScene();
      this.$mobile.showVr(land.vrId).then(function (res) {
        if (res.success) {
          if (res.data.vr) {
            var vr = res.data.vr;
            _this5.vrData = vr;
            _this5.vrSceneList = vr.vrSceneList;
            for (var x in _this5.vrSceneList) {
              var item = _this5.vrSceneList[x];

              _this5.vrSceneList[x] = item;
            }
            console.log('scenelist', _this5.vrSceneList);
            _this5.addAllScene(_this5.vrSceneList);
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ 834:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mcanvas__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mcanvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mcanvas__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var self = null;

var oldPrefix = 'http://193.112.137.199:8002',
    newPrefix = 'https://vr.gdyfpt.com';
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // 当前用户id
      userId: '',
      // vrId
      vrId: '',
      //  vr数据
      vrData: null,
      // 接口返回scene list
      vrSceneList: [],

      // 当前地块的下级地块，土地列表
      landList: [],
      // 当前地块
      currentLand: null,
      // 选中地块
      selectedLand: null,
      // 当前选择的下级地块
      currLowerLand: null,
      // 存储历史上级地块
      historyLand: [],

      // 其他菜单
      menus: [{
        name: '我要认购',
        url: '/farmPages/farm/purchaseLand',
        action: 'navigateTo'
      }, {
        name: '订餐',
        url: '/orderingPages/index',
        action: 'navigateTo'
      }, {
        name: '订房',
        url: '/bookingPages/index',
        action: 'navigateTo'
      }, {
        name: '购物',
        url: '/shopPages/shop/tabbar',
        action: 'navigateTo'
      }, {
        name: '实时视频',
        url: '/farmPages/farm/monitor',
        action: 'navigateTo'
      }],

      //krpano对象
      krpano: document.querySelector('#krpanoSWFObject'),
      //场景列表
      sceneList: [],
      //当前场景序号
      currentSceneIndex: -1,
      // 当前场景
      currentScene: null,
      //欢迎页场景序号
      welcomeSceneIndex: -1,
      //接口请求状态
      requesting: false,
      // 土地占位图
      placeholderImg: 'https://vr.gdyfpt.com/file/pic/20201026181417209173.png'
    };
  },
  created: function created() {
    var _this = this;

    // console.log('created', this.$route)
    self = this;
    window.onresize = function () {
      _this.getRem(7.5);
    };
    if (this.$route.query.vrId) {
      this.vrId = this.$route.query.vrId;
    }
    if (this.$route.query.userId) {
      this.userId = this.$route.query.userId;
    }
  },

  computed: {
    getLeftNum: function getLeftNum() {
      var arr = this.landList.filter(function (item) {
        return !item.userId;
      });
      return arr.length;
    },
    getTotalNum: function getTotalNum() {
      return this.landList.length;
    }
  },
  mounted: function mounted() {
    this.getRem(7.5);
    embedpano({
      // 该文件仅用于Flashplayer，而仅使用HTML5时，则不需要此文件。
      swf: "/static/tour.swf",
      xml: "/static/tour2.xml",
      target: "pano",
      html5: "auto",
      mobilescale: 1.0,
      // 布尔设置。设置为true时，来自html url的所有查询参数将作为变量传递给查看器。
      passQueryParameters: true,
      onready: this.onready
    });

    // 侦听场景切换
    window['onnewscene'] = function (val) {
      self.onnewscene(val);
    };
  },

  filters: {
    filterPrefix: function filterPrefix(imageStr) {
      if (typeof imageStr === 'string') {
        return imageStr.replace(oldPrefix, newPrefix);
      }
      return imageStr;
    }
  },
  watch: {
    // selectedLand: {
    //   handler(n, o) {
    //     console.log('selectedLand', n)
    //   },
    //   deep: true
    // }
  },
  methods: {
    menuBtnClick: function menuBtnClick(item) {
      console.log('item', item);
      var currentLand = this.currentLand;

      var action = item.action;
      var url = item.url;
      if (url.indexOf('purchaseLand') !== -1 && currentLand) {
        var hasParams = url.indexOf('?') !== -1;
        url += (hasParams ? '&' : '?') + 'areaLevel=' + currentLand.areaLevel + '&areaId=' + currentLand.id + '&parentId=' + currentLand.parentId;
      }
      switch (action) {
        case 'switchTab':
          uni.switchTab({
            url: url
          });
          break;
        case 'reLaunch':
          uni.reLaunch({
            url: url
          });
          break;
        case 'navigateBack':
          uni.navigateBack({
            delta: 1
          });
          break;
        default:
          uni[action]({
            url: url
          });
          break;
      }
    },
    getRem: function getRem(prem) {
      var html = document.getElementsByTagName("html")[0];
      var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = oWidth / prem + "px";
    },

    //入口js文件已将此函数定义到window，krpano加载完成后调用
    onready: function onready() {
      console.log('myready');
      this.krpano = document.querySelector('#krpanoSWFObject');

      //初始化场景
      this.sceneList = this.krpano.get('scene').getArray();

      //热点移动事件初始化
      var thisVue = this;
      var pano = document.querySelector('#pano');

      if (this.vrId) {
        this.getVrByLand({
          vrId: this.vrId
        }, true);
      } else {
        this.getManorDetails();
        this.getSubscription();
      }
    },

    // 跳转到购买地块页面
    toPurchaseDetail: function toPurchaseDetail() {
      uni.navigateTo({
        url: '/farmPages/farm/purchaseDetail?id=' + this.selectedLand.parentId + '&child=' + this.selectedLand.id
      });
    },

    // 加载全部场景
    addAllScene: function addAllScene(list) {
      var _this2 = this;

      if (!list) return;
      list.forEach(function (item, index) {
        var imageXmlStr = '';
        var previewXmlStr = item.previewurl ? '<preview url="' + item.previewurl + '"/>' : '';
        if (item.imageType == 1) {
          imageXmlStr = '\n          <image>\n              <sphere url="' + item.imageurl + '" />\n          </image>';
        } else if (item.imageType == 2) {
          var images = item.images ? item.images : [];
          var prefix = '';
          if (images.length > 0) {
            prefix = images[0].imageurl.split('_')[0];
          }
          imageXmlStr = '\n          <image type="CUBE">\n            <cube url="' + (prefix + '_%s.jpg') + '"/>\n          </image>';
        }
        _this2.krpano.call('addscene(' + item.name + ');');
        // 场景的title即为热点title文字，或热点的text
        _this2.krpano.set('scene[' + item.name + '].title', item.name);
        _this2.krpano.set('scene[' + item.name + '].imageurl', item.imageurl);
        _this2.krpano.set('scene[' + item.name + '].thumburl', item.thumburl);
        _this2.krpano.set('scene[' + item.name + '].images', images);
        _this2.krpano.set('scene[' + item.name + '].imagetype', item.imageType);
        // this.krpano.set('scene[' + item.name + '].welcomeFlag', item.welcomeFlag)
        _this2.krpano.set('scene[' + item.name + '].content', '\n          <view hlookat="' + (item.initH || 0) + '" vlookat="' + (item.initV || 0) + '" fovtype="MFOV" fov="' + item.fov + '" fovmin="' + item.fovmin + '" fovmax="' + item.fovmax + '" limitview="auto"/>\n          ' + previewXmlStr + imageXmlStr + ('\n          <autorotate enabled="' + (item.autorotate ? item.autorotate.enabled || false : false) + '" waittime="' + (item.autorotate ? item.autorotate.waitTime : 0) + '" accel="1.0" speed="5.0" horizon="0.0"/>\n          '));
        // addhotspot只在有场景时生效
      });

      // 同步数据到sceneList
      for (var x in this.sceneList) {
        var sceneData = list[x];
        if (sceneData) {
          // this.sceneList[x] = Object.assign(sceneData, this.sceneList[x])
          for (var column in sceneData) {
            if (!this.sceneList[x].hasOwnProperty(column)) {
              this.sceneList[x][column] = sceneData[column];
            }
          }
        }
      }

      // 加载初始化场景
      if (this.currentSceneIndex == -1 && this.sceneList) {
        var startIndex = this.sceneList.findIndex(function (item) {
          return item.welcomeFlag === 'true' || item.welcomeFlag === true;
        });
        if (startIndex !== -1) {
          this.welcomeSceneIndex = startIndex;
          this.changeScene(this.sceneList[startIndex], true);
        } else if (this.sceneList.length > 0) {
          // 没有设置初始场景，显示第一个
          this.changeScene(this.sceneList[0], true);
        }
      }
      // console.log('list', this.sceneList)
    },

    // 清除所有场景
    removeAllScene: function removeAllScene() {
      var _this3 = this;

      var sceneNames = this.krpano.get('scene').getArray().map(function (scene) {
        return scene.name;
      });
      // console.log('remove', sceneNames)
      // console.log(this.sceneList, this.sceneList.length)
      sceneNames.forEach(function (name) {
        _this3.krpano.set('scene[' + name + '].name', null);
      });
      // console.log(this.sceneList, this.sceneList.length)
      this.vrData = null;

      this.vrSceneList = [];
      this.currentSceneIndex = -1;
      this.welcomeSceneIndex = -1;
      // this.krpano.call('loadscene(二级地2)', null, 'REMOVESCENES');
    },

    // 侦听场景切换
    onnewscene: function onnewscene(sceneName) {
      // console.log('onnewscene', sceneName)
      if (this.currentScene.name != sceneName) {
        this.currentScene = this.sceneList.find(function (scene) {
          return scene.name == sceneName;
        });
        this.currentSceneIndex = this.currentScene ? this.currentScene.index : -1;
      }
      this.initHotSpot();
    },

    //根据krpano参数初始化视角和热点模块数据
    initView: function initView() {
      //初始化视角参数
      this.autoSpinWaitingTime = this.krpano.get('autorotate.waittime');
      this.autoSpinFlag = this.krpano.get('autorotate.enabled');
      this.minFov = this.krpano.get('view.fovmin');
      this.maxFov = this.krpano.get('view.fovmax');
      this.initFov = this.krpano.get('view.fov');
    },

    //热点初始化
    initHotSpot: function initHotSpot() {
      var _this4 = this;

      // adddhotspot之后热点并不会自动添加到场景中的hotspots中去，手动添加
      // hotspot的keep默认为false，切换场景后自动消失
      if (this.currentScene) {
        // 添加热点
        var hotSpots = this.currentScene.hotspots || this.currentScene.hotSpots;
        if (hotSpots) {
          hotSpots.forEach(function (hotSpot) {
            var linkedscene = hotSpot.linkedscene;
            _this4.krpano.call('addhotspot(' + hotSpot.name + ');');
            _this4.krpano.get('hotspot[' + hotSpot.name + ']').loadstyle(hotSpot.style);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].ath', hotSpot.ath);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].atv', hotSpot.atv);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].linkedscene', linkedscene);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].dive', hotSpot.dive);

            _this4.krpano.set('hotspot[' + hotSpot.name + '].bindvrid', hotSpot.bindVrId || hotSpot.bindvrid);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].areaid', hotSpot.areaId || hotSpot.areaid);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].hotspottype', hotSpot.hotspottype);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].areaname', hotSpot.areaName || hotSpot.areaname);
            _this4.krpano.set('hotspot[' + hotSpot.name + '].text', hotSpot.areaName || hotSpot.areaname);
            if (_this4.currentLand && _this4.currentLand.areaLevel == 3 && hotSpot.hotspottype == 2 && (hotSpot.areaid || hotSpot.areaId)) {
              var text = '可认购';
              var areaId = hotSpot.areaid || hotSpot.areaId;
              var land = _this4.landList.find(function (item) {
                return item.id == areaId;
              });
              // console.log('landList', this.landList)
              if (land && land.userId) {
                text = '已认购';
                // var mi = new MImage(newPrefix + '/file/pic/20201027171519278479.jpg')
                var mi = new __WEBPACK_IMPORTED_MODULE_0_mcanvas__["MImage"](land.userImg);
                mi.crop({
                  x: 'center',
                  y: 'center',
                  radius: '50%'
                });
                mi.draw({
                  type: 'png',
                  success: function success(b64) {
                    // console.log(b64)
                    self.krpano.set('hotspot[' + hotSpot.name + '].url', b64);
                  }
                });
                _this4.krpano.get('hotspot[' + hotSpot.name + ']').loadstyle('skin_hotspotstyle_tooltip');

                _this4.krpano.set('hotspot[' + hotSpot.name + '].width', '100');
                _this4.krpano.set('hotspot[' + hotSpot.name + '].height', '100');
              }
              _this4.krpano.set('hotspot[' + hotSpot.name + '].text', text);
            }
          });
        }
        if (this.sceneList[this.currentSceneIndex]) {
          this.sceneList[this.currentSceneIndex].hotspots = [];
        }
        this.krpano.get('hotspot').getArray().forEach(function (hotspot) {
          if (hotspot.name != 'webvr_prev_scene' && hotspot.name != 'webvr_next_scene' && hotspot.name != 'vr_cursor') {
            // console.log(this.currentSceneIndex, this.sceneList.length, this.sceneList)
            if (_this4.sceneList[_this4.currentSceneIndex]) {
              _this4.sceneList[_this4.currentSceneIndex].hotspots.push(hotspot);
            }
            _this4.initHotspotEvent(hotspot);
          }
        });
        // console.log(this.sceneList)
      }
    },

    // 通过场景名称获取关联数据
    getSceneDataByName: function getSceneDataByName(scene) {
      if (!scene) return null;
      if (this.vrSceneList) {
        var sceneItem = this.vrSceneList.find(function (item) {
          return item.name === scene.name;
        });
        return sceneItem;
      }
      return null;
    },

    //切换操作模块
    changeModule: function changeModule(module) {
      this.module = module;
    },

    //切换当前场景
    changeScene: function changeScene(scene) {
      var fisheye = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      // console.log('change', scene, this.currentSceneIndex)
      // console.log(this.vrSceneList)
      // console.log(this.sceneList)
      if (this.currentSceneIndex == scene.index) return;

      this.currentSceneIndex = scene.index;
      this.currentScene = this.sceneList[this.currentSceneIndex];
      this.krpano.call('loadscene(' + scene.name + ')');
      var currentScene = this.sceneList[this.currentSceneIndex];
      //加载临时存储数据应用于krpano
      //自动旋转
      if (currentScene.autorotate) {
        this.krpano.set('autorotate.enabled', currentScene.autorotate.enabled);
        this.krpano.set('autorotate.waittime', currentScene.autorotate.waitTime);
      }
      if (this.autoSpinFlag) this.krpano.get('autorotate').interrupt();
      //视角
      // if (currentScene.initH) this.krpano.set('view.hlookat', currentScene.initH)
      // if (currentScene.initV) this.krpano.set('view.vlookat', currentScene.initV)
      // if (currentScene.fovmax) this.krpano.set('view.fovmax', currentScene.fovmax)
      // if (currentScene.fovmin) this.krpano.set('view.fovmin', currentScene.fovmin)
      // if (currentScene.fov) this.krpano.set('view.fov', currentScene.fov)


      if (currentScene.fovmin) this.krpano.set('view.fovmin', currentScene.fovmin);
      if (fisheye) {
        this.krpano.set('view.fisheye', '1.0');
        this.krpano.set('view.stereographic', true);
        this.krpano.set('view.fovmax', 150);
        this.krpano.set('view.hlookat', currentScene.initH ? 180 + Number(currentScene.initH) : 180);
        this.krpano.set('view.vlookat', 90);
        this.krpano.set('view.fov', 150);

        this.krpano.call('setfish(' + currentScene.initH + ', ' + currentScene.initV + ', ' + currentScene.fov + ')');
      } else {
        this.krpano.set('view.fisheye', '0.0');
        this.krpano.set('view.stereographic', false);
        if (currentScene.fovmax) this.krpano.set('view.fovmax', currentScene.fovmax);
        if (currentScene.initH) this.krpano.set('view.hlookat', currentScene.initH);
        if (currentScene.initV) this.krpano.set('view.vlookat', currentScene.initV);
        if (currentScene.fov) this.krpano.set('view.fov', currentScene.fov);
      }

      //初始化模块数据
      this.initView();
      // this.initHotSpot()
    },

    //热点事件初始化
    initHotspotEvent: function initHotspotEvent(hotspot) {
      if (hotspot.hotspottype == 2 && hotspot.areaid) {
        hotspot.onclick = function () {
          var land = self.landList.find(function (item) {
            return item.id == hotspot.areaid;
          });
          if (land) {
            // if(land.areaLevel == 4) {
            //   self.selectedLand = land
            // } else {
            self.toLowerLand(land);
            // }
          }
        };
      }
      // hotspot.onclick = function () {

      // }
      // hotspot.onloaded = function () {
      // self.addHotSpotTip()
      // }
    },

    // 获取一级土地详情
    getManorDetails: function getManorDetails() {
      this.$mobile.getManorDetails(2).then(function (res) {
        if (res.data && res.data.vrId) {
          self.currentLand = res.data;
          self.getVrByLand(self.currentLand);
        }
      });
    },

    // 获取一级下的二级
    getSubscription: function getSubscription() {
      this.$mobile.getSubscription().then(function (res) {
        if (res.success) {
          self.landList = res.data.filter(function (item) {
            return item.id != -1;
          });
        }
      });
    },

    // 获取二级下的三级
    getSubscriptionType: function getSubscriptionType(id) {
      this.$mobile.getSubscriptionType({
        id: id
      }).then(function (res) {
        if (res.success) {
          self.landList = res.data;
        }
      });
    },

    // 获取三级详情，及三级下的四级
    getManorFourArea: function getManorFourArea(id) {
      this.$mobile.getManorFourArea(id).then(function (res) {
        if (res.success) {
          self.landList = res.data.fourAreaList;
          self.initHotSpot();
        } else {
          self.landList = [];
        }
      });
    },

    // 根据级别获取土地列表
    getLandListByLevel: function getLandListByLevel(level, land) {
      // console.log('get', level, land)
      if (level == 1) {} else if (level == 2) {
        this.getSubscription();
      } else if (level == 3) {
        this.getSubscriptionType(land.id);
      } else if (level == 4) {
        this.getManorFourArea(land.id);
      } else {
        this.landList = [];
      }
    },

    // 前往上级
    toHigherLand: function toHigherLand() {
      console.log('toHigherLand', this.historyLand);
      if (this.historyLand.length > 0) {
        this.currentLand = this.historyLand.pop();
        this.selectedLand = null;
        this.getVrByLand(this.currentLand);
        this.getLandListByLevel(this.currentLand.areaLevel + 1, this.currentLand);
      }
    },

    // 前往下级
    toLowerLand: function toLowerLand(land) {
      // console.log('toLowerLand', land)
      if (land.areaLevel == 4 && this.userId && land.userId && this.userId != land.userId) {
        this.$message.warning('该地块已被认购');
        return;
      }
      this.historyLand.push(this.currentLand);
      this.currentLand = land;
      if (land.areaLevel == 4) {
        this.selectedLand = land;
      }
      this.getVrByLand(this.currentLand);
      this.getLandListByLevel(this.currentLand.areaLevel + 1, this.currentLand);
    },

    // 通过vrid跳转到对应土地
    toLandByVrId: function toLandByVrId(vrId) {
      var item = this.landList.find(function (item) {
        return item.vrId === vrId;
      });
      if (item) {
        this.currLowerLand = item;
        this.toLowerLand();
      }
    },

    // 获取土地关联vr
    getVrByLand: function getVrByLand(land) {
      var _this5 = this;

      var changeTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!land.vrId) {
        this.$message.warning('该地块暂无vr');
        return;
      }
      this.removeAllScene();
      this.$mobile.showVr(land.vrId).then(function (res) {
        if (res.success) {
          if (res.data.vr) {
            var vr = res.data.vr;
            _this5.vrData = vr;
            _this5.vrSceneList = vr.vrSceneList;
            for (var x in _this5.vrSceneList) {
              var item = _this5.vrSceneList[x];
              for (var index in item) {
                if (typeof item[index] == 'string' && item[index].indexOf('http://193.112.137.199:8002') !== -1) {
                  item[index] = item[index].replace(oldPrefix, newPrefix);
                }
              }
              if (item.images) {
                item.images = item.images.map(function (imageItem) {
                  imageItem.imageurl = imageItem.imageurl.replace(oldPrefix, newPrefix);
                  return imageItem;
                });
              }
              _this5.vrSceneList[x] = item;
            }
            console.log('scenelist', _this5.vrSceneList);
            _this5.addAllScene(_this5.vrSceneList);
          }
          if (res.data.fourArea && changeTitle) {
            document.title = res.data.fourArea.areaName;
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_network__ = __webpack_require__(76);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var token = localStorage.getItem('token');
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      title: '添加场景',
      headers: {
        'Authorization': token
      },
      fileList: [],
      fileListCover: [],
      fileListPreview: [],
      otherParams: {
        name: 'test'
      },
      // typeId   type: 'u'
      typeParams: {
        name: 'test'
      },
      form: this.$form.createForm(this),
      sceneName: '',
      imageTypeOptions: [{
        id: 1,
        text: '球形全景图'
        // text: 'Sphere',
      }, {
        id: 2,
        text: '立方体全景图'
        // text: 'Cube'
      }],
      imageType: 1,
      previewImage: '',
      previewVisible: false,
      uploadItems: [{
        side: 'u',
        name: '上',
        path: ''
      }, {
        side: 'd',
        name: '下',
        path: ''
      }, {
        side: 'l',
        name: '左',
        path: ''
      }, {
        side: 'r',
        name: '右',
        path: ''
      }, {
        side: 'f',
        name: '前',
        path: ''
      }, {
        side: 'b',
        name: '后',
        path: ''
      }]
    };
  },

  methods: {
    getImagePrefix: function getImagePrefix() {
      for (var x in this.uploadItems) {
        var item = this.uploadItems[x];
        if (item.path) {
          var parts = item.path.split('/');
          var prefix = parts.pop().split('_')[0];
          return prefix;
        }
      }
      return '';
    },
    beforeUpload: function beforeUpload(file, item) {
      this.typeParams = {
        name: 'test',
        type: item.side,
        typeId: this.getImagePrefix()
      };
      return true;
    },

    // modal confirm
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.form.validateFields(function (err, values) {
        if (!err) {
          // console.log('values', values)
          if (_this.fileListCover.length === 0) {
            _this.$message.warning('请先上传封面图');
            return;
          }
          if (_this.imageType == 1 && _this.fileList.length === 0) {
            _this.$message.warning('请先上传全景图');
            return;
          } else if (_this.imageType == 2) {
            for (var x in _this.uploadItems) {
              var item = _this.uploadItems[x];
              if (!item.path) {
                _this.$message.warning('请补全立方体全景图片');
                return;
              }
            }
          }

          var thumburl = _this.fileListCover[0].url;
          var previewurl = _this.fileListPreview.length > 0 ? _this.fileListPreview[0].url : '';
          var imageurl = _this.fileList.length > 0 ? _this.fileList[0].url : '';
          var images = _this.imageType === 2 ? _this.uploadItems.map(function (item) {
            return {
              imageurl: item.path,
              side: item.side
            };
          }) : null;
          thumburl = thumburl ? thumburl.replace(':8001', ':8002') : '';
          imageurl = imageurl ? imageurl.replace(':8001', ':8002') : '';
          previewurl = previewurl ? previewurl.replace(':8001', ':8002') : '';
          images = images ? images.map(function (item) {
            item.imageurl = item.imageurl.replace(':8001', ':8002');
            return item;
          }) : images;
          _this.$emit('confirm', {
            sceneName: values.sceneName,
            imageType: _this.imageType,
            thumburl: thumburl,
            imageurl: imageurl,
            previewurl: previewurl,
            images: images
          });
        }
      });
    },
    afterClose: function afterClose() {
      this.form.resetFields();
      this.fileList = [];
      this.fileListCover = [];
      this.fileListPreview = [];
      this.uploadItems = this.uploadItems.map(function (item) {
        item.path = '';
        return item;
      });
      this.title = '添加场景';
    },
    setFileList: function setFileList(value) {
      var _this2 = this;

      console.log('set', value);
      if (value.imageurl) {
        this.fileList = [{
          url: value.imageurl,
          uid: '-1',
          name: 'image.png',
          status: 'done'
        }];
      }
      if (value.thumburl) {
        this.fileListCover = [{
          url: value.thumburl,
          uid: '-1',
          name: 'cover.png',
          status: 'done'
        }];
      }
      if (value.previewurl) {
        this.fileListPreview = [{
          url: value.previewurl,
          uid: '-1',
          name: 'preview.png',
          status: 'done'
        }];
      }
      if (value.images) {
        this.uploadItems = this.uploadItems.map(function (item) {
          var imageItem = value.images.find(function (imageItem) {
            return imageItem.side === item.side;
          });
          if (imageItem) {
            item.path = imageItem.imageurl;
          }
          return item;
        });
      }
      this.imageType = value.imageType ? value.imageType : 1;
      this.$nextTick(function () {
        _this2.form.setFieldsValue({
          sceneName: value.sceneName
        });
      });
      this.title = '编辑场景';
    },

    // 单据照片预览
    handlePreview: function handlePreview(path) {
      this.previewImage = path;
      this.previewVisible = true;
    },
    handleRemove: function handleRemove(index) {
      this.uploadItems[index].path = '';
    },
    handleChange: function handleChange(info, type, index) {
      // console.log('info', info, type, index)
      var file = info.file,
          fileList = info.fileList;

      fileList = fileList.slice(-1);
      fileList = fileList.map(function (file) {
        if (file.response && file.response.path) {
          var path = file.response.path;
          var idx = path.indexOf('/file');
          path = 'https://vr.gdyfpt.com' + path.slice(idx);
          file.url = path;
        }
        return file;
      });

      if (type === 'cover') {
        this.fileListCover = fileList;
      } else if (type === 'preview') {
        this.fileListPreview = fileList;
      } else {
        if (this.imageType === 1) {
          this.fileList = fileList;
        } else {
          var item = this.uploadItems[index];
          if (file.status === 'uploading') {
            item.path = '';
            item.loading = true;
            this.$set(this.uploadItems, index, item);
            return;
          }
          if (file.status === 'done') {
            if (file.response && file.response.path) {
              var path = file.response.path;
              var idx = path.indexOf('/file');
              item.path = 'https://vr.gdyfpt.com' + path.slice(idx);
              item.loading = false;
              this.$set(this.uploadItems, index, item);
              this.$message.success(file.name + ' \u4E0A\u4F20\u6210\u529F');
            } else {
              this.$message.error(file.name + ' \u4E0A\u4F20\u5931\u8D25');
            }
          }
        }
      }
    }
  }
});

/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 查询地块的级别
    areaLevel: {
      type: Number,
      default: 0
    },
    // 当前地块id
    areaId: {}
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      options: [],
      vrId: '',
      areaName: ''
    };
  },

  computed: {},
  watch: {
    visible: function visible(n, o) {
      if (n) {
        this.getOptions();
      }
    }
  },
  methods: {
    // modal confirm
    initForm: function initForm(value) {
      console.log('init', value);
      this.vrId = value.bindVrId;
      this.areaName = value.areaName;
      this.form.setFieldsValue({
        value: value.bindVrId
      });
    },
    getOptions: function getOptions() {
      var _this = this;

      if (!this.areaLevel || !this.areaId) return;
      this.$api.unBindArea({
        areaLevel: this.areaLevel,
        areaId: this.areaId
      }).then(function (res) {
        if (res.content) {
          var options = res.content.filter(function (item) {
            return item.vrId;
          });
          if (_this.vrId) {
            options.unshift({
              vrId: _this.vrId,
              areaName: _this.areaName
            });
          }
          _this.options = options;
        }
      });
    },
    handleSubmit: function handleSubmit(e) {
      var _this2 = this;

      var self = this;
      e.preventDefault();
      this.form.validateFields(function (err, values) {
        if (!err) {
          var landItem = self.options.find(function (item) {
            return item.vrId === values.value;
          });
          values.areaId = landItem.id;
          values.areaLevel = landItem.areaLevel;
          _this2.$emit('submit', values);
        }
      });
    },
    toLandByVr: function toLandByVr() {
      if (this.vrId) {
        this.$emit('to-land', this.vrId);
      }
    },
    afterClose: function afterClose() {
      this.vrId = '';
      this.form.resetFields();
    }
  }
});

/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var token = localStorage.getItem('token');

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 父级地块的级别
    areaLevel: {
      type: Number,
      default: 0
    },
    hasBtn: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      purchased: false,
      headers: {
        'Authorization': token
      },
      otherParams: {
        name: ''
      },
      fileList: []
    };
  },
  mounted: function mounted() {},

  computed: {
    title: function title() {
      var level = '';
      switch (this.areaLevel) {
        case 1:
          level = '二级';break;
        case 2:
          level = '三级';break;
        case 3:
          level = '四级';break;
      }
      return level + '地块';
    }
  },
  methods: {
    // modal confirm
    initForm: function initForm(formValue) {
      var columns = ['areaName'];
      if (this.areaLevel >= 1) {
        columns = columns.concat(['areaTitle', 'areaBrief']);
      }
      if (this.areaLevel >= 2) {
        columns = columns.concat(['monitorLink', 'price']);
      }
      if (this.areaLevel >= 3) {
        columns = columns.concat(['plotSize', 'deliveryCount', 'effectYear']);
      }
      console.log('init', formValue, columns);
      if (formValue.areaImg) {
        this.fileList = [{
          url: formValue.areaImg,
          uid: '-1',
          name: 'image.png',
          status: 'done'
        }];
      }
      this.form.setFieldsValue(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.pick(formValue, columns));
      // if(formValue.purchased) {
      //   this.purchased = true
      //   this.$nextTick(() => {
      //     this.form.setFieldsValue(formValue)
      //   })
      // } else {
      // }
    },
    beforeUpload: function beforeUpload(file) {
      this.otherParams.name = file.name;
      return true;
    },
    handleSubmit: function handleSubmit(e) {
      var _this = this;

      e.preventDefault();
      this.form.validateFields(function (err, values) {
        if (!err) {
          // console.log('Received values of form: ', values);
          // console.log('submit', this.fileList)
          if (_this.fileList.length > 0) {
            values.areaImg = _this.fileList[0].url;
          }
          if (values.deadline) {
            values.deadline = values.deadline.format('YYYY-MM-DD');
          }
          // if(values.effectYear) {
          //   values.effectYear = values.effectYear.format('YYYY-MM-DD')
          // }
          _this.$emit('submit', values);
        }
      });
    },
    switchChange: function switchChange(checked, event) {
      this.purchased = checked;
    },
    toLower: function toLower() {
      this.$emit('to-lower');
    },
    dele: function dele() {
      this.$emit('delete');
    },
    afterClose: function afterClose() {
      this.fileList = [];
      this.form.resetFields();
    },
    handleChange: function handleChange(info) {
      var fileList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(info.fileList));
      fileList = fileList.slice(-1);

      fileList = fileList.map(function (file) {
        if (file.response && file.response.path) {
          var path = file.response.path;
          var index = path.indexOf('/file');
          path = 'https://vr.gdyfpt.com' + path.slice(index);
          // path = baseURL + path.slice(index)
          file.url = path;
        }
        return file;
      });

      this.fileList = fileList;
    }
  }
});

/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mydialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = postAction;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAction;
/* unused harmony export exportAction */
/* unused harmony export exportAction1 */
/* unused harmony export httpAction */
/* harmony export (immutable) */ __webpack_exports__["c"] = putAction;
/* unused harmony export getFileAction */
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteAction;
/* harmony export (immutable) */ __webpack_exports__["e"] = downFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_network__ = __webpack_require__(76);



//post
function postAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["c" /* axios */])({
    url: url,
    method: 'post',
    data: parameter,
    headers: headers
  });
}

//get
function getAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["c" /* axios */])({
    url: url,
    method: 'get',
    params: parameter,
    headers: headers
  });
}

//导出
function exportAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["c" /* axios */])({
    url: url,
    method: 'post',
    data: parameter,
    responseType: 'blob',
    headers: headers
  });
}
//导出
function exportAction1(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["c" /* axios */])({
    url: url,
    method: 'post',
    data: parameter,
    responseType: 'arraybuffer',
    headers: headers
  });
}

//post method= {post | put}
function httpAction(url, parameter, method) {
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["c" /* axios */])({
    url: url,
    method: method,
    data: parameter,
    headers: headers
  });
}

//put
function putAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["c" /* axios */])({
    url: url,
    method: 'put',
    data: parameter,
    headers: headers
  });
}

//get pdf file
function getFileAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["c" /* axios */])({
    url: url,
    method: 'get',
    params: parameter,
    timeout: 0,
    headers: headers
  });
}

//deleteAction
function deleteAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["c" /* axios */])({
    url: url,
    method: 'delete',
    data: parameter,
    headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headers, {
      'Content-Type': 'application/json'
    })
  });
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
function downFile(url, parameter) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["c" /* axios */])({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  });
}

/***/ }),

/***/ 840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = postAction;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAction;
/* unused harmony export exportAction */
/* unused harmony export exportAction1 */
/* unused harmony export httpAction */
/* harmony export (immutable) */ __webpack_exports__["c"] = putAction;
/* unused harmony export getFileAction */
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteAction;
/* unused harmony export downFile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_network__ = __webpack_require__(76);



//post
function postAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["a" /* ajax */])({
    url: url,
    method: 'post',
    data: parameter,
    headers: headers
  });
}

//get
function getAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["a" /* ajax */])({
    url: url,
    method: 'get',
    params: parameter,
    headers: headers
  });
}

//导出
function exportAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["a" /* ajax */])({
    url: url,
    method: 'post',
    data: parameter,
    responseType: 'blob',
    headers: headers
  });
}
//导出
function exportAction1(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["a" /* ajax */])({
    url: url,
    method: 'post',
    data: parameter,
    responseType: 'arraybuffer',
    headers: headers
  });
}

//post method= {post | put}
function httpAction(url, parameter, method) {
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["a" /* ajax */])({
    url: url,
    method: method,
    data: parameter,
    headers: headers
  });
}

//put
function putAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["a" /* ajax */])({
    url: url,
    method: 'put',
    data: parameter,
    headers: headers
  });
}

//get pdf file
function getFileAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["a" /* ajax */])({
    url: url,
    method: 'get',
    params: parameter,
    timeout: 0,
    headers: headers
  });
}

//deleteAction
function deleteAction(url, parameter) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  console.log('ddd', headers);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["a" /* ajax */])({
    url: url,
    method: 'delete',
    data: parameter,
    headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headers, {
      'Content-Type': 'application/json'
    })
  });
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
function downFile(url, parameter) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_network__["a" /* ajax */])({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  });
}

/***/ }),

/***/ 841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ls__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ant_design_vue_dist_antd_css__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ant_design_vue_dist_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ant_design_vue_dist_antd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_api__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_mobileApi__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bulma__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bulma___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bulma__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









//noinspection ES6UnusedImports


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Vue.use(Button).use(Icon);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_ls___default.a, {
  namespace: 'pro__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$message = __WEBPACK_IMPORTED_MODULE_4_ant_design_vue__["b" /* message */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$api = __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$mobile = __WEBPACK_IMPORTED_MODULE_7__api_mobileApi__["a" /* default */];

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  // el: '#editor',
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
  // template: '<Editor ref="editor"/>',
  // components: {Editor}
});

/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VueAxios; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);

var VueAxios = {
    vm: {},
    // eslint-disable-next-line no-unused-vars
    install: function install(Vue) {
        var router = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var instance = arguments[2];

        if (this.installed) {
            return;
        }
        this.installed = true;

        if (!instance) {
            // eslint-disable-next-line no-console
            console.error('You have to install axios');
            return;
        }

        Vue.axios = instance;

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
            axios: {
                get: function get() {
                    return instance;
                }
            },
            $http: {
                get: function get() {
                    return instance;
                }
            }
        });
    }
};



/***/ }),

/***/ 906:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 907:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 908:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 909:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 910:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 911:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 912:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 913:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[841]);


// WEBPACK FOOTER //
// static/js/app.d38087001cebd3cbc772.js